// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:37:41.235Z
// Property: Cavalli at Iron Horse Station (ID: 5737427910000640)
// Collections: 26 amenities, 11 floorplans (live), 31 photos, 81 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5737427910000640",
  "property_external_id": "4951746",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cavalli-at-iron-horse-station-n-richland-hills-tx/s14stb7",
  "property_google_business_url": "https://www.google.com/maps/place/Cavalli+at+Iron+Horse+Station/@32.8468866,-97.2465004,17z/data=!4m13!1m7!3m6!1s0x864e781557eb2bc9:0x6d0a8c84e6a08513!2s6490+Iron+Horse+Blvd,+North+Richland+Hills,+TX+76180!3b1!8m2!3d32.8468866!4d-97.2443117!3m4!1s0x864e7965bd0aedfd:0x3057a69064fbc637!8m2!3d32.8468866!4d-97.2443117",
  "property_linkedin_url": null,
  "property_hubspot_id": "8007243961",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cavalli-at-iron-horse-station",
  "property_name": "Cavalli at Iron Horse Station",
  "property_website_url": "https://www.lifeatcavalli.com/",
  "property_domain": "https://www.lifeatcavalli.com/",
  "property_address": "6490 Iron Horse Blvd",
  "property_full_address": "6490 Iron Horse Blvd, North Richland Hills, TX 76180",
  "property_address_1": "6490 Iron Horse Blvd",
  "property_address_2": null,
  "property_address_city": "North Richland Hills",
  "property_address_state": "TX",
  "property_address_zip_full": "76180-6117",
  "property_address_zip": "76180",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Iron Horse",
  "property_address_latitude": "32.8459713",
  "property_address_longitude": "-97.24484939999999",
  "property_email": "cavalli@alapts.com",
  "property_phone": "(469) 892-7100",
  "property_call_tracking_phone": "817-904-5595",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Polished apartment living in North Richland Hills.</strong> Explore modern studio to three-bedroom <a href=\"/floor-plans\">floor plans</a> with elevated finishes, inviting community spaces, and easy access to daily conveniences—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cavalli at Iron Horse Station in person.</p>",
  "property_long_description": "<p><strong>Polished apartment living in the Iron Horse district.</strong> Cavalli at Iron Horse Station pairs modern studio, one-, two-, and three-bedroom layouts with the everyday ease of North Richland Hills—near Loop 820, Iron Horse Golf Course, Cotton Belt Trail connections, and the North Richland Hills/Iron Horse TEXRail station for service toward Fort Worth, Grapevine, and DFW Airport.</p><p>Inside, you can choose a home with details like stainless steel appliances, designer cabinetry and backsplash, wood-style flooring, tall ceilings, in-home washer and dryer options, private patios or balconies, and select fenced yards. Beyond your door, <a href=\"/amenities\">community amenities</a> bring more room to unwind: a resort-style pool with cabanas, BBQ and picnic spaces, a strength and cardio studio, yoga/flex studio, game room, resident lounge, package lockers, EV charging, controlled-access entry, and a dog park with pet spa. From nearby parks and trails to City Point dining, shopping, and neighborhood conveniences, Cavalli keeps you connected to the best of North Richland Hills.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019d02f4-1ca8-7625-bad6-658fbc936140.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and cabanas in front of apartment buildings.",
    "public_id": "019d02f4-1ca8-7625-bad6-658fbc936140",
    "storage_key": "property/5737427910000640/019d02f4-1ca8-7625-bad6-658fbc936140.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.90243902439023",
  "property_admin_fee": "200",
  "property_application_fee": "50",
  "property_fees_deposit_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, refundable deposit of $300 per pet, with a monthly pet rent of $15 per pet. Breed restrictions may apply.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "15",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, refundable pet deposit of $300 per pet, with a monthly pet rent of $15 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, refundable pet deposit of $300 per pet, with a monthly pet rent of $15 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8838189.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://cavalli.loftliving.com/login",
  "property_apply_now_url": "https://8838189.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e4389-b457-734f-8cab-00e3bb38ec29.webp",
  "property_primary_logo_media": {
    "alt_text": "Cavalli at Iron Horse Station logo",
    "public_id": "019e4389-b457-734f-8cab-00e3bb38ec29",
    "storage_key": "property/5737427910000640/019e4389-b457-734f-8cab-00e3bb38ec29.webp",
    "width": 1818,
    "height": 537
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019d02f4-0f01-708d-85f3-3839ff48161f.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f4-0f01-708d-85f3-3839ff48161f",
    "storage_key": "property/5737427910000640/019d02f4-0f01-708d-85f3-3839ff48161f.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e4389-b380-7243-ac58-86b07bfe3b5f.webp",
  "property_icon_media": {
    "alt_text": "The logo for Iron Horse Station, featuring a large golden C.",
    "public_id": "019e4389-b380-7243-ac58-86b07bfe3b5f",
    "storage_key": "property/5737427910000640/019e4389-b380-7243-ac58-86b07bfe3b5f.webp",
    "width": 511,
    "height": 511
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e4389-b382-777c-a86f-eaac05128914.webp",
  "property_fav_icon_media": {
    "alt_text": "The logo for Iron Horse Station, featuring a stylized capital C.",
    "public_id": "019e4389-b382-777c-a86f-eaac05128914",
    "storage_key": "property/5737427910000640/019e4389-b382-777c-a86f-eaac05128914.webp",
    "width": 659,
    "height": 659
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f153c-cafd-73c6-921c-5fc7f206f5e4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f153c-cafd-73c6-921c-5fc7f206f5e4",
    "storage_key": "property/5737427910000640/019f153c-cafd-73c6-921c-5fc7f206f5e4.webp",
    "width": 693,
    "height": 400
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e4389-b42e-76ce-8c77-374291db7d35.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cavalli at Iron Horse Station logo",
    "public_id": "019e4389-b42e-76ce-8c77-374291db7d35",
    "storage_key": "property/5737427910000640/019e4389-b42e-76ce-8c77-374291db7d35.webp",
    "width": 693,
    "height": 400
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#444b2c",
  "property_secondary_color": "#f7c47f",
  "property_font_color": "#2e2a25",
  "property_color_4": "#9d7847",
  "property_color_3": "#798750",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "605 - 1298",
  "property_sqft_min": "605",
  "property_sqft_max": "1298",
  "property_price_range": "1337 - 2290",
  "property_price_min": "1337",
  "property_price_max": "2290",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/CavalliatIronHorseStation",
  "property_instagram_url": "https://www.instagram.com/cavalliatironhorsestation",
  "property_twitter_url": "https://twitter.com/CavalliApts",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_e0KvWV5ToYRN8b7ZJCmVzA",
  "property_youtube_url": "https://www.youtube.com/@cavalliatironhorseapartments",
  "property_yelp_url": "https://www.yelp.com/biz/oxford-at-iron-horse-north-richland-hills",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Recharge, refocus, and unwind with ease.</strong> Cavalli at Iron Horse Station brings everyday convenience together with standout spaces, from the pool and BBQ areas to the strength/cardio studio, yoga/flex studio, game room, and resident lounge. Controlled-access gates, package lockers, covered parking options, storage, and car-charging stations keep things running smoothly, while apartment features like hard-surface flooring, tall ceilings, USB outlets, and included washer/dryer features add modern polish at home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with polish, options with ease.</strong><br>Explore studio, one-, two-, and three-bedroom apartments at Cavalli at Iron Horse Station, with current pricing and availability made simple. Open living areas, hard-surface flooring, tall ceilings, washers and dryers, modern appliances, and USB outlets add everyday function, while select homes offer fenced yards, French doors, or garden tubs for an extra touch of character.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Cavalli in full color.</strong> Preview bright interiors with wood-style flooring, tall ceilings, gray-cabinet kitchens, stainless steel appliances, and pendant-lit counters. Then see the everyday extras: double vanities, walk-in closets, select private outdoor spaces, poolside cabanas, a textured resident lounge, game room, and fitness space with pool views. Browse the gallery, then come see it all in person.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected North Richland Hills living starts here.</strong> Cavalli at Iron Horse Station places TEXRail access nearby for trips toward Fort Worth, Grapevine, and DFW Airport, with Loop 820 and Rufe Snow favorites close to home. Start with breakfast at Blue Mound Café, plan dinner at Babe’s, explore City Point’s growing mix, or head outside near Iron Horse Golf Course and Cotton Belt Trail connections.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews highlight the details that count.</strong> At Cavalli at Iron Horse Station, feedback often points to a clean, well-kept community, responsive service, and a team described as accommodating, personable, and ready to help. Visitors also call out welcoming tour experiences and “spectacular” amenities. Read the reviews to see more first-hand impressions.</p>",
  "property_neighborhood_blurb": "<p><strong>Move through North Richland Hills with more options.</strong> From Cavalli at Iron Horse Station, your neighborhood starts with a nearby TEXRail stop for rides toward Fort Worth, Grapevine, and DFW Airport, then opens into everyday favorites along Loop 820 and Rufe Snow. Grab homestyle breakfast at Blue Mound Café, meet up for fried chicken at Babe’s, or see what’s taking shape at City Point’s walkable mix of dining, retail, and green space. When you want fresh air, the Iron Horse area keeps its railroad character in view, from creekside fairways at Iron Horse Golf Course to nearby Cotton Belt Trail connections. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how connected this North Richland Hills address feels.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living with room to recharge.</strong> At Cavalli at Iron Horse Station, your day can shift easily from poolside lounging to a focused workout in the strength/cardio studio or yoga/flex studio, then into a relaxed evening in the game room, resident lounge, or BBQ areas. Practical perks keep the experience smooth, too, with controlled-access gates, package lockers, covered parking options, storage spaces, online resident services, and car-charging stations.</p><p>Inside your apartment, modern finishes add polish without fuss—hard-surface flooring, tall ceilings, kitchen appliances, USB outlets, and included washer/dryer features help streamline daily routines. Select homes add extras like fenced yards, French doors, and garden tubs. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these amenities come together in North Richland Hills.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Cavalli.</strong> Choose a modern studio, one-, two-, or three-bedroom apartment with polished finishes, everyday comfort, and connected North Richland Hills living. When you’re ready, apply online and take the next step toward calling Cavalli at Iron Horse Station home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Cavalli at Iron Horse Station for help finding your way, exploring modern studio, one-, two-, and three-bedroom layouts, or learning more about polished apartment living in North Richland Hills.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Cavalli at Iron Horse Station?</strong> Start here for quick answers on apartment layouts, leasing details, amenities, pet-friendly features, and everyday living in North Richland Hills. If you need more help, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong><br>At Cavalli at Iron Horse Station, you can compare efficient studio apartments, flexible one-bedroom homes, comfortable two-bedroom layouts, and spacious three-bedroom residences in one easy place. As you browse current pricing and availability, look for details that make each plan feel polished and practical—open living areas, hard-surface flooring, tall ceilings, included washers and dryers, modern kitchen appliances, USB outlets, and select homes with fenced yards, French doors, or garden tubs.</p><p>Whether you want a streamlined home base or extra room to spread out in North Richland Hills, these floor plans give you options without overcomplicating the search. Explore the <a href=\"/amenities\">features and finishes</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the style before you step inside.</strong> The gallery at Cavalli at Iron Horse Station brings the experience into focus: light-filled apartments with wood-style flooring, tall ceilings, and kitchens framed by gray cabinetry, gleaming counters, stainless steel appliances, and warm pendant lighting.</p><p>Swipe from open living areas to the details that shape each day—double vanities, walk-in closets, and private outdoor space in select homes—then move into community scenes made for downtime: cabanas beside the pool, a lounge with rich textures and statement lighting, a game room with shuffleboard and foosball, and a bright fitness space overlooking the pool area. Like what you see? Compare layouts on the <a href=\"/floor-plans\">floor plans</a> page, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cavalli in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Cavalli from every angle.</strong> Use the interactive map to browse available apartments and see how North Richland Hills living connects you to nearby trails, transit, dining, shopping, and everyday conveniences around the Iron Horse district.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living, right at home.</strong> At Cavalli at Iron Horse Station, your cat or dog has more than a place to stay—they have everyday conveniences built around them. Bring up to two pets with no weight limit, then make the most of an on-site bark park, a Posh Pet Spa for post-play cleanups, and select homes with fenced yards for easy outdoor time.</p><p>For a bigger change of scenery, nearby Tipps Canine Hollow gives dogs an off-leash park option in North Richland Hills, while Cavalli’s walkable community spaces make daily strolls simple. Explore more pet-friendly <a href=\"/amenities\">community amenities</a>, or <a href=\"/contact-us\">contact the leasing team</a> with questions about current pet policy details and breed guidelines.</p>",
  "property_referafriend_blurb": "<p><strong>Share polished apartment living at Cavalli.</strong> Invite a friend to discover modern layouts, stylish in-home finishes, and relaxing spaces like the resort-style pool, resident lounge, and dog park. Send a referral today and let them see what makes life in the Iron Horse district easy to love.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Cavalli.</strong><br>Keep everyday living simple with quick online tools to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying polished apartment living in North Richland Hills.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real service.</strong> As you read through reviews for Cavalli at Iron Horse Station, you’ll notice praise for the details that make an apartment experience feel easier: a clean, well-presented community, helpful team members, and prompt attention when questions or maintenance needs come up.</p><p>Reviewers call the community “very nice” and clean, with staff described as accommodating, personable, and ready to help. Tour experiences stand out, too, with one visitor noting that the amenities were “spectacular” and that the team made the visit feel genuinely welcoming. Explore the ratings below to see what people are saying in their own words.</p>",
  "property_created_at": "1752256658562",
  "property_scheduletour_blurb": "<p><strong>See Cavalli at Iron Horse Station in person.</strong> Tour modern studio, one-, two-, and three-bedroom layouts with polished finishes, then explore spaces made for easy downtime—from the resort-style pool to the resident lounge and fitness studios. Schedule your tour today and picture your next home in North Richland Hills.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Cavalli at Iron Horse Station leasing team will be in touch soon. In the meantime, picture polished apartment living with modern layouts, stylish in-home finishes, inviting spaces to unwind, and everyday North Richland Hills convenience close at hand.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the community before you arrive.</strong> The Cavalli at Iron Horse Station Community Tour lets you move through the spaces that shape the property experience—from polished shared interiors with warm textures and natural light to amenity areas designed for downtime, movement, and everyday convenience. Take your time, pause on the details, and get a better feel for the flow, finishes, and atmosphere without leaving your screen.</p><p>Use the virtual tour as your first look, then explore the <a href=\"/gallery\">photo gallery</a> or compare <a href=\"/amenities\">community amenities</a> before you <a href=\"/schedule-a-tour\">schedule a tour</a> in North Richland Hills. It’s an easy way to narrow your search and picture how Cavalli comes together in real life.</p>",
  "property_copyright": "2025 All Rights Reserved. Cavalli at Iron Horse Station",
  "property_seo_title_home": "Cavalli at Iron Horse Station | Apartments in N Richland Hills, TX",
  "property_seo_description_home": "Discover your perfect haven at Cavalli at Iron Horse Station in N Richland Hills, TX! Explore a variety of floor plans, from studios to three-bedroom apartments, tailored to fit your lifestyle. Enjoy top-notch amenities like a dog park, serene pool, and modern game room. With convenient features such as covered parking, car charging stations, and LUXER package lockers, your comfort is our priority. Don't miss out on our upcoming upgrades and online resident services. Find your new home today and embrace a community that feels like family!",
  "property_seo_title_floorplans": "Floor Plans | studio - 3 Apartments in N Richland Hills, TX",
  "property_seo_description_floorplans": "Discover your ideal home at Cavalli at Iron Horse Station in N Richland Hills, TX! Explore our diverse floor plans, including stylish studios, spacious one, two, and three-bedroom apartments. Each layout is designed to fit your lifestyle seamlessly. Browse our available apartment homes today and find the perfect floor plan that suits your needs!",
  "property_seo_title_amenities": "Amenities | N Richland Hills, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the perfect blend of comfort and convenience at Cavalli at Iron Horse Station in N Richland Hills, TX. Explore a variety of stunning floor plans, from studios to three bedrooms, designed for every lifestyle. Enjoy exceptional amenities including a resort-style pool, dog park, game room, and a yoga studio. Our modern apartments feature tall ceilings, garden tubs, and upgraded kitchen appliances, all with online resident services for your ease. Don’t miss out on our upcoming features like LUXER Package Lockers and car charging stations! Experience the best—explore our amazing community amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in N Richland Hills, TX",
  "property_seo_description_gallery": "Experience the lifestyle you deserve at Cavalli at Iron Horse Station in N Richland Hills, TX! Explore our stunning photo gallery showcasing our diverse floor plans—Studio, One, Two, and Three Bedrooms, designed for every need. Enjoy exceptional amenities like a resort-style pool, dog park, game room, and modern conveniences including a LUXER Package Locker and USB outlets. Picture yourself living in a space with tall ceilings, covered parking, and upgraded features. Dive into a vibrant community that offers online resident services, a yoga studio, and BBQ areas. Discover your new home today—view our gallery and see why you'll love living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Cavalli at Iron Horse Station Apartments",
  "property_seo_description_virtualtours": "\"Explore Cavalli at Iron Horse Station in N Richland Hills, TX, where modern living meets comfort. Take a virtual tour of our stunning studio, one, two, and three-bedroom apartments! Discover your ideal floor plan today and envision your new home. Ready to begin? Take a virtual tour of our community and apartments for rent!\"",
  "property_seo_title_interactivemap": "Interactive Map | Cavalli at Iron Horse Station Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Cavalli at Iron Horse Station in N Richland Hills, TX! Choose from a variety of spacious floor plans, including studio, one, two, and three-bedroom options. Enjoy premium amenities like a sparkling pool, dog park, game room, and covered parking. With easy online resident services and upgraded features, your comfort and convenience are a priority. Use our interactive community map to explore available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in N Richland Hills, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Cavalli at Iron Horse Station in N Richland Hills, TX. Explore our diverse floor plans—studio, one, two, and three-bedroom apartments—and uncover local favorites and nearby attractions. See what's around our community and elevate your lifestyle today!",
  "property_seo_title_contact": "Contact Us | Cavalli at Iron Horse Station",
  "property_seo_description_contact": "Discover your dream home at Cavalli at Iron Horse Station in N Richland Hills, TX! Explore our diverse floor plans, including studios, one-bedroom, two-bedroom, and three-bedroom apartments, designed to fit your lifestyle. Have questions about our community or need assistance? Contact our leasing team today for personalized support and let us help you find the perfect apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in N Richland Hills, TX",
  "property_seo_description_faqs": "Explore Cavalli at Iron Horse Station in N Richland Hills, TX! Discover our diverse floor plans—from stylish studios to spacious three-bedroom apartments. Enjoy top-notch amenities, including a dog park, pool, game room, and more. Have questions? Browse our FAQs page for all the answers about our community and lifestyle. Your perfect apartment awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in N Richland Hills, TX",
  "property_seo_description_reviews": "Experience modern living at Cavalli at Iron Horse Station in N Richland Hills, TX! Explore our diverse floor plans, including studios and spacious three-bedroom apartments, all featuring top-notch amenities like a dog park, pool, game room, and convenient online resident services. Discover why our community is the perfect place to call home—see what our residents have to say! ",
  "property_seo_title_applynow": "Apply Now | Apartments in N Richland Hills, TX",
  "property_seo_description_applynow": "Discover your perfect home at Cavalli at Iron Horse Station in N Richland Hills, TX! Choose from spacious floor plans including studio, one, two, and three-bedroom apartments, all featuring modern amenities such as a serene dog park, inviting game room, refreshing pool, and convenient car charging stations. Enjoy added perks like our LUXER package locker and online resident services. Don’t miss out—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Cavalli at Iron Horse Station",
  "property_seo_description_residentaccess": "\"Log in to your Cavalli at Iron Horse Station resident portal in N Richland Hills, TX! Manage your account, pay rent, schedule maintenance, and enjoy seamless community living. Access your services with ease today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Cavalli at Iron Horse Station",
  "property_seo_description_referafriend": "\"Refer a friend to Cavalli at Iron Horse Station in N Richland Hills, TX, and help them discover their new home! Great friends make great neighbors—share the joy of our vibrant community today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Cavalli at Iron Horse Station",
  "property_seo_description_scheduletour": "\"Discover your new home at Cavalli at Iron Horse Station in N Richland Hills, TX! Schedule a tour today to explore our modern apartments and vibrant community amenities that make living here a truly unique experience.\"",
  "property_seo_title_privacy": "Privacy Policy | Cavalli at Iron Horse Station",
  "property_seo_description_privacy": "Discover how Cavalli at Iron Horse Station in N Richland Hills, TX, prioritizes your privacy. Learn about our data protection practices and commitment to safeguarding your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Cavalli at Iron Horse Station",
  "property_seo_description_accessibility": "Discover Cavalli at Iron Horse Station in N Richland Hills, TX, where we prioritize digital accessibility for all. Our commitment to inclusivity ensures everyone can easily navigate our community's resources. Join us in creating a welcoming environment – because at Cavalli, everyone matters!",
  "property_seo_title_sitemap": "Sitemap | Cavalli at Iron Horse Station",
  "property_seo_description_sitemap": "Discover a world of convenience at Cavalli at Iron Horse Station in N Richland Hills, TX. Explore our sitemap to easily navigate our apartment community's amenities, features, and offerings. Your perfect home awaits—view our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | Cavalli at Iron Horse Station",
  "property_seo_description_thankyou": "Thank you for your interest in Cavalli at Iron Horse Station! We're excited to help you find your perfect home in N Richland Hills, TX. A team member will reach out shortly to assist you with your inquiries. Stay tuned for exciting updates and leasing opportunities!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319560",
  "amenities": [
    {
      "id": "custom_2ea4d4eb-d957-4a4b-a0fb-43f390c4c80f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c65467c7-b205-4ac1-a685-e7c5a9b6f773",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000593",
      "title": "*Coming Soon",
      "amount": "0.0000",
      "description": "**Coming Soon",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79b992f0-daf2-48a2-ad8d-96d35aaeb9d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6047cd5b-c5cd-493d-adfa-1707d82faaed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f219d22-b683-45ae-9749-b40dd6df7c6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry & Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_693c549d-76de-47d7-884a-183aba500209",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee6aad73-c0e4-4767-ac92-0977ff89cc78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d427471-3ef6-4812-b234-8ab892e5bff4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e558e358-3e7c-4223-a2c1-826c36909f5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Private Fenced Yards*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1fbd320-ba34-4983-86cd-c895353628fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000637",
      "title": "French Doors",
      "amount": "0.0000",
      "description": "Exterior French Doors*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_859b2a91-8f08-48e9-879a-cd3b35bd60a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Resident Gameroom w/ Foosball",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d41c73bb-cde5-4304-b407-be9637ad9c3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs or Walk-In Showers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff04c826-7d69-4795-9497-cf4adfc26c0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Vinyl-Wood Plank Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec2a8a23-b261-4e6a-a7e0-bf27c8a85d6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Kitchen Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff72eabd-627c-421f-b224-db0e65c3f6ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b654c800-7242-474f-8cf5-b724a4e2f17a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios or Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_149d228c-97a9-45fc-8d2d-5edb4d0d260a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffa2ac67-7f09-41f2-8fac-2aa33cd18c0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e628aa32-f0b7-47a8-9900-88a47ffe1bf3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Onsite Storage Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ab6d3ab-6d80-44c6-b0e5-08231fe03023",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9 Ceilings w/ Custom Light Fixtures*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b62b6f75-050a-40e2-ba41-39f7742f6a0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_666c11a0-7704-4f0b-b007-6a5bbc096a5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eae6a48c-6f5f-4a25-9d2b-bb0ba22f75ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Resident Picnic & BBQ Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_456e9c10-57bc-46c9-b79f-856adfd08378",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Resident Lounge w/ WiFi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e3fd170-d7a9-4043-ad29-6439cf8cad02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000002334",
      "title": "Resident Convenience Store",
      "amount": "0.0000",
      "description": "Community Convenience Store**",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_203d5387-8a8c-4ea7-b529-fb8bc710d193",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "external_id": "P000002466",
      "title": "Yoga/Flex Studio",
      "amount": "0.0000",
      "description": "Modern Strength Training & Cardio Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_39abbf53-6aa2-4938-bba5-66725088357b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-4a4e-71b7-a50e-051797bc86a2.webp",
      "image_media": {
        "alt_text": "Yoga studio with mirrors and ballet barre, weight balls and yoga mats visible.",
        "public_id": "019e8985-4a4e-71b7-a50e-051797bc86a2",
        "storage_key": "property/5737427910000640/019e8985-4a4e-71b7-a50e-051797bc86a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community yoga studio features large mirrors, a ballet barre, and all the equipment you need for a great workout.",
      "link": "",
      "alt_text": "Yoga studio with mirrors and ballet barre, weight balls and yoga mats visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d4d25e7-cc32-457f-acd3-791b16f2c9ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-498b-776d-9932-4a3e4ae85509.webp",
      "image_media": {
        "alt_text": "Living room with gray sectional sofa, two accent chairs, and horse-themed art.",
        "public_id": "019e8985-498b-776d-9932-4a3e4ae85509",
        "storage_key": "property/5737427910000640/019e8985-498b-776d-9932-4a3e4ae85509.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sectional sofa, two unique accent chairs, and a collection of framed horse art on the wall. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with gray sectional sofa, two accent chairs, and horse-themed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d89e5e98-d60b-4d0f-8a88-f51952d4c35e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-4232-7671-9777-2801e844eff1.webp",
      "image_media": {
        "alt_text": "Modern living room with comfortable seating, shelving, and a TV.",
        "public_id": "019e8985-4232-7671-9777-2801e844eff1",
        "storage_key": "property/5737427910000640/019e8985-4232-7671-9777-2801e844eff1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, decorative shelving, and a large television for your entertainment.",
      "link": "",
      "alt_text": "Modern living room with comfortable seating, shelving, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82af3602-fd9b-4bd3-aef7-448831d09c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-4c90-71cd-bf0a-46e072fae565.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large bathtub and white marble-look tile shower surround.",
        "public_id": "019e8985-4c90-71cd-bf0a-46e072fae565",
        "storage_key": "property/5737427910000640/019e8985-4c90-71cd-bf0a-46e072fae565.webp",
        "width": 2998,
        "height": 1999
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in this stylish bathroom featuring a deep soaking tub and a chic marble-look tile shower enclosure. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a large bathtub and white marble-look tile shower surround.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f49c72a3-1a94-467b-833c-5f99bdf98072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-46c0-722c-92e3-b96645a3177e.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and modern gray cabinets.",
        "public_id": "019e8985-46c0-722c-92e3-b96645a3177e",
        "storage_key": "property/5737427910000640/019e8985-46c0-722c-92e3-b96645a3177e.webp",
        "width": 2993,
        "height": 1995
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom featuring a double vanity with granite countertops and ample storage.",
      "link": "",
      "alt_text": "Double vanity bathroom with granite countertops and modern gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1f23053-3e65-441c-8a7c-61010f4bd5e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-3d9b-7778-8e51-643616f9f9a0.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor pool with lounge chairs and a seating area with a fire pit.",
        "public_id": "019e8985-3d9b-7778-8e51-643616f9f9a0",
        "storage_key": "property/5737427910000640/019e8985-3d9b-7778-8e51-643616f9f9a0.webp",
        "width": 3061,
        "height": 2041
      },
      "title": "Community",
      "description": "Enjoy the resort-style outdoor pool area with comfortable lounge chairs, a relaxing fire pit, and cabana seating. Perfect for unwinding and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor pool with lounge chairs and a seating area with a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed173174-0f42-4580-bfc2-d493a1446dea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2446-74c8-b3e4-7d84061a4ca9.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a dark facade, stone accents, and balconies under a cloudy blue sky.",
        "public_id": "019e8985-2446-74c8-b3e4-7d84061a4ca9",
        "storage_key": "property/5737427910000640/019e8985-2446-74c8-b3e4-7d84061a4ca9.webp",
        "width": 2863,
        "height": 1909
      },
      "title": "Community",
      "description": "Discover the elegance of our modern apartment complex, featuring striking architecture, private balconies, and convenient resident parking.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with a dark facade, stone accents, and balconies under a cloudy blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1c4b326-6f0f-41e6-ab9d-4177e578cdfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-39ff-75e9-8998-8d99e529762f.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen island with seating and decorative sliding doors.",
        "public_id": "019e8985-39ff-75e9-8998-8d99e529762f",
        "storage_key": "property/5737427910000640/019e8985-39ff-75e9-8998-8d99e529762f.webp",
        "width": 3001,
        "height": 2001
      },
      "title": "Community",
      "description": "A chic communal kitchen island with counter seating, leading to stylish sliding doors with abstract art, and a comfortable lounge area beyond.",
      "link": "",
      "alt_text": "Modern communal kitchen island with seating and decorative sliding doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd200f83-857d-484b-a0dd-577d008894ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-3482-76a6-b66b-4d7b60fd7b67.webp",
      "image_media": {
        "alt_text": "Sculptural horses in a roundabout in front of apartment buildings.",
        "public_id": "019e8985-3482-76a6-b66b-4d7b60fd7b67",
        "storage_key": "property/5737427910000640/019e8985-3482-76a6-b66b-4d7b60fd7b67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Unique horse sculptures welcome you to this apartment community, surrounded by modern architecture.",
      "link": "",
      "alt_text": "Sculptural horses in a roundabout in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88669b8d-f9e9-480c-9d1d-90e8b633dd9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2b5a-73cb-bfec-0bda151e1cb9.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with seating and lounge chair.",
        "public_id": "019e8985-2b5a-73cb-bfec-0bda151e1cb9",
        "storage_key": "property/5737427910000640/019e8985-2b5a-73cb-bfec-0bda151e1cb9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a modern grilling station, comfortable seating, and a unique lounge pod.",
      "link": "",
      "alt_text": "Outdoor grilling area with seating and lounge chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9cf8a2ba-ab8e-4b27-be1e-198485743723",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2c74-73bf-ac9f-4eb91851ccf5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a kitchen island.",
        "public_id": "019e8985-2c74-73bf-ac9f-4eb91851ccf5",
        "storage_key": "property/5737427910000640/019e8985-2c74-73bf-ac9f-4eb91851ccf5.webp",
        "width": 2978,
        "height": 1986
      },
      "title": "Apartment",
      "description": "Experience the convenience and style of our modern kitchens, featuring sleek light gray cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35fb3627-6d9e-4d35-9e57-4516e365fe8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-310a-7048-b5a5-97cdd6ce0cc3.webp",
      "image_media": {
        "alt_text": "Cozy lounge area with plush seating, bookshelves, and a coffee table.",
        "public_id": "019e8985-310a-7048-b5a5-97cdd6ce0cc3",
        "storage_key": "property/5737427910000640/019e8985-310a-7048-b5a5-97cdd6ce0cc3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed resident lounge, featuring comfortable seating, a curated library, and stylish decor.",
      "link": "",
      "alt_text": "Cozy lounge area with plush seating, bookshelves, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0e32377-71c9-478a-a468-e85fb68ac023",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2815-702b-8d6d-7467b0977f9d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
        "public_id": "019e8985-2815-702b-8d6d-7467b0977f9d",
        "storage_key": "property/5737427910000640/019e8985-2815-702b-8d6d-7467b0977f9d.webp",
        "width": 2979,
        "height": 1986
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a large island with seating, sleek cabinetry, and designer finishes.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e825517b-78b2-485f-a081-fd3a7397fc20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-27ac-7464-b46d-c88034f72eaa.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed and view into the en-suite bathroom.",
        "public_id": "019e8985-27ac-7464-b46d-c88034f72eaa",
        "storage_key": "property/5737427910000640/019e8985-27ac-7464-b46d-c88034f72eaa.webp",
        "width": 2999,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Experience comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and direct access to a modern en-suite bathroom.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed and view into the en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_86ba28fc-1962-446d-8ad9-4c228cfb0982",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2741-734a-9bdd-61d690cdeed1.webp",
      "image_media": {
        "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "019e8985-2741-734a-9bdd-61d690cdeed1",
        "storage_key": "property/5737427910000640/019e8985-2741-734a-9bdd-61d690cdeed1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool with in-water lounge chairs and plenty of space to sunbathe.",
      "link": "",
      "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de813873-8af2-41a8-be91-f897c372133c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2241-73b1-b2b0-51c15e943365.webp",
      "image_media": {
        "alt_text": "Living room with a brown leather sofa, armchair, and a modern kitchen in the background.",
        "public_id": "019e8985-2241-73b1-b2b0-51c15e943365",
        "storage_key": "property/5737427910000640/019e8985-2241-73b1-b2b0-51c15e943365.webp",
        "width": 2654,
        "height": 1965
      },
      "title": "Apartment",
      "description": "Enjoy a comfortable living space with a stylish brown leather sofa and a modern, fully-equipped kitchen perfect for everyday living.",
      "link": "",
      "alt_text": "Living room with a brown leather sofa, armchair, and a modern kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1d11350-9f95-475a-85be-19ef95f6c8df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-1d3a-75ce-bec1-0f866654e651.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with plush seating and modern decor.",
        "public_id": "019e8985-1d3a-75ce-bec1-0f866654e651",
        "storage_key": "property/5737427910000640/019e8985-1d3a-75ce-bec1-0f866654e651.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating, elegant lighting, and tasteful artwork.",
      "link": "",
      "alt_text": "Stylish lounge area with plush seating and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7493ac3-7b72-4fd4-a59a-8b01f17641c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-1da2-7453-9e7c-899df9c1d0b5.webp",
      "image_media": {
        "alt_text": "Metal horse sculptures in a roundabout in front of apartment buildings.",
        "public_id": "019e8985-1da2-7453-9e7c-899df9c1d0b5",
        "storage_key": "property/5737427910000640/019e8985-1da2-7453-9e7c-899df9c1d0b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community, featuring unique metal horse sculptures at the entrance. The modern apartment buildings offer comfortable living spaces with stunning exterior architecture.",
      "link": "",
      "alt_text": "Metal horse sculptures in a roundabout in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_617ee68c-de7f-42b2-8aaa-cf9aac435470",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-1480-752b-b095-ead66131a812.webp",
      "image_media": {
        "alt_text": "Two modern bar stools in front of a brick accent wall with a framed piece of abstract art and built-in desks.",
        "public_id": "019e8985-1480-752b-b095-ead66131a812",
        "storage_key": "property/5737427910000640/019e8985-1480-752b-b095-ead66131a812.webp",
        "width": 2994,
        "height": 1996
      },
      "title": "Community",
      "description": "Work or relax at the integrated desks, perfect for remote work or studying, complemented by stylish bar stools and decorative art.",
      "link": "",
      "alt_text": "Two modern bar stools in front of a brick accent wall with a framed piece of abstract art and built-in desks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38fc7bd5-8acf-4464-9cb1-7a98b5044991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-102e-7719-a042-350509cea2b6.webp",
      "image_media": {
        "alt_text": "Pet grooming station with washing tubs and a dryer.",
        "public_id": "019e8985-102e-7719-a042-350509cea2b6",
        "storage_key": "property/5737427910000640/019e8985-102e-7719-a042-350509cea2b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Groom your furry friend at our state-of-the-art pet spa, featuring professional grooming tubs and a high-velocity dryer.",
      "link": "",
      "alt_text": "Pet grooming station with washing tubs and a dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_544a604e-a784-448e-840c-701f6a91a1d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-1150-71d6-be96-c75a06a47ed2.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with attached garages.",
        "public_id": "019e8985-1150-71d6-be96-c75a06a47ed2",
        "storage_key": "property/5737427910000640/019e8985-1150-71d6-be96-c75a06a47ed2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building showcasing its architectural details and attached garages.",
      "link": "",
      "alt_text": "Exterior of apartment building with attached garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c32ad8f2-c78d-425c-b1ab-08d2ebe843da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-056a-7098-b459-a151694f6302.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs, adjacent to a building with stone accents and large windows.",
        "public_id": "019e8985-056a-7098-b459-a151694f6302",
        "storage_key": "property/5737427910000640/019e8985-056a-7098-b459-a151694f6302.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor seating area, perfect for enjoying the fresh air and beautiful surroundings.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and chairs, adjacent to a building with stone accents and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_331f88d9-59cd-4822-938e-dcd0404c4691",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-06c3-767d-9ab6-fec64341b449.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard, foosball table, and comfortable seating.",
        "public_id": "019e8985-06c3-767d-9ab6-fec64341b449",
        "storage_key": "property/5737427910000640/019e8985-06c3-767d-9ab6-fec64341b449.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy endless fun and relaxation in our vibrant community lounge, featuring a shuffleboard table, foosball, and plush seating areas perfect for socializing.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard, foosball table, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87f0ad58-4869-4b61-9132-f70b6637fa44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-0753-72f2-bcb4-a4f79391ef30.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with tables and chairs, and a unique hanging lounge chair.",
        "public_id": "019e8985-0753-72f2-bcb4-a4f79391ef30",
        "storage_key": "property/5737427910000640/019e8985-0753-72f2-bcb4-a4f79391ef30.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our modern outdoor grilling station, complete with seating and a cozy hanging lounge chair for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor grilling area with tables and chairs, and a unique hanging lounge chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e11773a-2b02-4a30-91e2-e179c33f7210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-0686-729f-ae55-84519f678fbe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, seating, and coffee station.",
        "public_id": "019e8985-0686-729f-ae55-84519f678fbe",
        "storage_key": "property/5737427910000640/019e8985-0686-729f-ae55-84519f678fbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this modern kitchen featuring a large island with seating, a convenient coffee station, and ample cabinet space. Perfect for entertaining or casual gatherings.",
      "link": "",
      "alt_text": "Modern kitchen with island, seating, and coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e91a3d1c-bc0a-4c92-86fd-8d7af5c67fb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-06d0-72be-b3a9-9f75eda2cb0e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e8985-06d0-72be-b3a9-9f75eda2cb0e",
        "storage_key": "property/5737427910000640/019e8985-06d0-72be-b3a9-9f75eda2cb0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2df00966-4f71-411e-817a-1e6e5ca0f2f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-06b4-74bf-b65b-41fb9c76fe13.webp",
      "image_media": {
        "alt_text": "Coffee station with K-cups, sweeteners, stirrers, cups, and coffee maker.",
        "public_id": "019e8985-06b4-74bf-b65b-41fb9c76fe13",
        "storage_key": "property/5737427910000640/019e8985-06b4-74bf-b65b-41fb9c76fe13.webp",
        "width": 2217,
        "height": 1478
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our convenient coffee station, featuring a variety of K-cup flavors, sweeteners, and all the essentials for a perfect cup.",
      "link": "",
      "alt_text": "Coffee station with K-cups, sweeteners, stirrers, cups, and coffee maker.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_501ec5e6-b6b0-4fa1-81d9-1916d125fdcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-065f-75ad-bc71-90f576df85e6.webp",
      "image_media": {
        "alt_text": "Cavalli at Iron Horse Station monument sign and building exterior",
        "public_id": "019e8985-065f-75ad-bc71-90f576df85e6",
        "storage_key": "property/5737427910000640/019e8985-065f-75ad-bc71-90f576df85e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the Cavalli at Iron Horse Station apartment building, featuring its modern architecture and prominent monument sign.",
      "link": "",
      "alt_text": "Cavalli at Iron Horse Station monument sign and building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81bea0fd-9269-4dfa-a09d-e3eec865a1df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8984-f2e0-7222-8b58-349e0b8e5057.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment: elliptical machines, stationary bikes, and treadmills.",
        "public_id": "019e8984-f2e0-7222-8b58-349e0b8e5057",
        "storage_key": "property/5737427910000640/019e8984-f2e0-7222-8b58-349e0b8e5057.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with treadmills, ellipticals, and stationary bikes.",
      "link": "",
      "alt_text": "Gym with cardio equipment: elliptical machines, stationary bikes, and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f666baf-c1c0-45cb-bbb6-38ba5ae17f26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8984-f425-740e-a4c0-d21f184deedd.webp",
      "image_media": {
        "alt_text": "Modern lobby seating area with a reception desk and chairs.",
        "public_id": "019e8984-f425-740e-a4c0-d21f184deedd",
        "storage_key": "property/5737427910000640/019e8984-f425-740e-a4c0-d21f184deedd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish lobby, featuring comfortable seating and a welcoming reception area. Perfect for meeting guests or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern lobby seating area with a reception desk and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72429569-51a8-4880-9a24-55a30d1465d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8984-f277-7431-aa47-f3846d51a204.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and subway tile backsplash, stainless steel appliances.",
        "public_id": "019e8984-f277-7431-aa47-f3846d51a204",
        "storage_key": "property/5737427910000640/019e8984-f277-7431-aa47-f3846d51a204.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a large island with a granite countertop and a white subway tile base. Equipped with modern stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop and subway tile backsplash, stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_66a5bec640b56fa1f2bd1e68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Mi Pueblo",
      "poi_type": "Restaurants",
      "poi_address": "8010 Bedford Euless Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Mexican murals & a fireplace play backdrop to fajitas, seafood & margaritas at this comfy eatery.",
      "poi_long_description": "Mexican murals & a fireplace play backdrop to fajitas, seafood & margaritas at this comfy eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-526f-774d-bf94-cc75df62c9ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-526f-774d-bf94-cc75df62c9ed",
        "storage_key": "property/5737427910000640/019f150f-526f-774d-bf94-cc75df62c9ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mipueblorestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12203471722318235759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-pueblo",
      "poi_latitude": "32.8338074",
      "poi_longitude": "-97.2077461",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-605-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZmnQ-R4ToYRb4hN699wW6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_86dfe749a9bf8e9b7afc91fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8020 Bedford Euless Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-57d1-7517-b6f3-9fde574d2a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-57d1-7517-b6f3-9fde574d2a5d",
        "storage_key": "property/5737427910000640/019f150f-57d1-7517-b6f3-9fde574d2a5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/north-richland-hills/north-richland-hills-northeast-mall/1039?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:north-richland-hills-tx-1039_pl:locurl_rd:1018",
      "poi_directions_map_url": "https://maps.google.com/?cid=14147742746366204462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "32.833855",
      "poi_longitude": "-97.207368",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-581-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62IKR-R4ToYRLlrE4hHhVsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_e4b7afc3c414a5be799b6e93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Ernie's Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8206 Bedford Euless Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Fried seafood anchors this casual eatery, also serving landlubber eats, in a cheerful, basic space.",
      "poi_long_description": "Fried seafood anchors this casual eatery, also serving landlubber eats, in a cheerful, basic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-5ced-7742-a870-4a6e0fac5969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5ced-7742-a870-4a6e0fac5969",
        "storage_key": "property/5737427910000640/019f150f-5ced-7742-a870-4a6e0fac5969.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "http://www.erniesseafood.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890713608113448636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernies-seafood-restaurant",
      "poi_latitude": "32.8337497",
      "poi_longitude": "-97.2054229",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-498-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1ickOZ4ToYRvGZJMG66xcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_35b5fc2eb6b61733ec8e38a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Japan House",
      "poi_type": "Restaurants",
      "poi_address": "7536 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "All-you-can-eat sushi spot with a robot serving staff and a menu of traditional cooked dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-583a-7066-bc1b-7d501bee32a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-583a-7066-bc1b-7d501bee32a3",
        "storage_key": "property/5737427910000640/019f150f-583a-7066-bc1b-7d501bee32a3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.japanhouseusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2011682202796859710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "japan-house",
      "poi_latitude": "32.82895",
      "poi_longitude": "-97.2202468",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-537-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyoWRqV5ToYRPqGuGk7u6hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_32028cc829cd3cb38cf9c687",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Heavenly Crust Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8721 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual option for thin-crust, NY-style pizzas (many are jumbo-sized) alongside salads and lasagna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-4cec-711c-83eb-ccb91728c8ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-4cec-711c-83eb-ccb91728c8ad",
        "storage_key": "property/5737427910000640/019f150f-4cec-711c-83eb-ccb91728c8ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://heavenlycrust.com/heavenlycrustpizza-v3q1sa?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9892364473966148819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heavenly-crust-pizza",
      "poi_latitude": "32.8468249",
      "poi_longitude": "-97.1973396",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-479-3077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZpo_vx5ToYR0zxyuxO9SIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_ba5ec15ab40929390c43e272",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "McAlister's Deli",
      "poi_type": "Restaurants",
      "poi_address": "9143 Blvd 26 Suite 600, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_long_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-6d00-71ea-adff-2f5dcf25924d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-6d00-71ea-adff-2f5dcf25924d",
        "storage_key": "property/5737427910000640/019f150f-6d00-71ea-adff-2f5dcf25924d.webp",
        "width": 1280,
        "height": 1072
      },
      "poi_business_url": "https://locations.mcalistersdeli.com/tx/north-richland-hills/9143-boulevard-26?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=2908520833719858370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalisters-deli",
      "poi_latitude": "32.8544208",
      "poi_longitude": "-97.1885295",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-485-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2SWysB4ToYRwvSxy0kkXSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_270bdb95dfe4b4bddec6cd9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Chan's Mongolian Grill",
      "poi_type": "Restaurants",
      "poi_address": "9147 TX-26 #450, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual, contemporary spot where diners create their own stir-fry dishes using almost a dozen sauces.",
      "poi_long_description": "Casual, contemporary spot where diners create their own stir-fry dishes using almost a dozen sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-4c63-700f-9635-998350acdaf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-4c63-700f-9635-998350acdaf9",
        "storage_key": "property/5737427910000640/019f150f-4c63-700f-9635-998350acdaf9.webp",
        "width": 643,
        "height": 642
      },
      "poi_business_url": "https://www.chansmongoliangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16099111662748066008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chans-mongolian-grill",
      "poi_latitude": "32.8551008",
      "poi_longitude": "-97.1889964",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-788-5117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2SWysB4ToYR2GByscKIa98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mongolian_barbecue_restaurant"
    },
    {
      "id": "ec_cf7054956dafb87a3910dee3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "9127 Grapevine Hwy Ste 100, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-5c29-75f1-9400-6fb54378cc15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5c29-75f1-9400-6fb54378cc15",
        "storage_key": "property/5737427910000640/019f150f-5c29-75f1-9400-6fb54378cc15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/tx/north-richland-hills/9127-grapevine-hwy?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=424",
      "poi_directions_map_url": "https://maps.google.com/?cid=17499125415763819677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "32.8534353",
      "poi_longitude": "-97.1902293",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-428-9770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0d3erd4ToYRnbyc7tlh2fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_afa7474b0a69ca9117a82c6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Tandoor Wok - Asian Fusion Restaurant-Zabiha Halal Certified",
      "poi_type": "Restaurants",
      "poi_address": "9127 Blvd 26 #140, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Family-run eatery for flavorful Indian dishes and pad Thai offerings from Chinese and Asian cuisines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-4e0a-73b3-9553-beb3f6860cb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-4e0a-73b3-9553-beb3f6860cb4",
        "storage_key": "property/5737427910000640/019f150f-4e0a-73b3-9553-beb3f6860cb4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://tandoorwok.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=590406178753390215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tandoor-wok---asian-fusion-restaurant-zabiha-halal-certified",
      "poi_latitude": "32.8538153",
      "poi_longitude": "-97.1905803",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-576-3737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZzSU5QV5ToYRh6bKnUqLMQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_2ca2a6f48c191ca2b003f74f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Cristina's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9159 Grapevine Hwy #300, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Informal Tex-Mex fare & margaritas star at this roomy branch of a statewide chain.",
      "poi_long_description": "Informal Tex-Mex fare & margaritas star at this roomy branch of a statewide chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-4ff0-745f-9d18-cd548fea7b26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-4ff0-745f-9d18-cd548fea7b26",
        "storage_key": "property/5737427910000640/019f150f-4ff0-745f-9d18-cd548fea7b26.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.cristinasmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15863170453994316470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cristinas-mexican-restaurant",
      "poi_latitude": "32.85527",
      "poi_longitude": "-97.1873787",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-520-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ33SWysB4ToYRtqLNMXtNJdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_7704cc3302d1b8e16adf12e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Barrel & Bones Craft Bar and Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "9143 Grapevine Hwy #620, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-7f3b-713e-aae6-03f83f9c0d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7f3b-713e-aae6-03f83f9c0d17",
        "storage_key": "property/5737427910000640/019f150f-7f3b-713e-aae6-03f83f9c0d17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://orders.barrelandbones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7419959058276983226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrel--bones-craft-bar-and-smokehouse",
      "poi_latitude": "32.8546223",
      "poi_longitude": "-97.1884974",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-393-3118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2mEbm95ToYRuqGKbHP9-GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_eeebeb3b5dc4f6c30af86ab3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Babe's Chicken Dinner House",
      "poi_type": "Restaurants",
      "poi_address": "6700 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_long_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-74a3-748d-9759-8e290e558478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-74a3-748d-9759-8e290e558478",
        "storage_key": "property/5737427910000640/019f150d-74a3-748d-9759-8e290e558478.webp",
        "width": 1126,
        "height": 804
      },
      "poi_business_url": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5977819841032846300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-chicken-dinner-house",
      "poi_latitude": "32.839435",
      "poi_longitude": "-97.237305",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-428-4298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW563zIt5ToYR3HsLPHl79VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_5ca59c0697c151b490c1ca0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Soulman's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "6000 Rufe Snow Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual Texas-style BBQ chain serving ribs, sandwiches, plates & family-style meal options.",
      "poi_long_description": "Casual Texas-style BBQ chain serving ribs, sandwiches, plates & family-style meal options.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJW25-WAB5ToYRGuoqJSeV96o/photos/AaVGc3nhD2I8x16i3xq0T7V0jHNEyG2XoTrz-fzovf21qvbDJuSnGSgAiJXqOjUOAsPHJESmMZPssZSyfJlm43opuS1KtYCKzuEjW-pGxhOEILApTkOZncpjDx18dxUdPMISpE0gozrYb1DJ-n4PUd3hC7-WWycC_fZR_bR_bagoYDOV1UeJjwUl-WBOqfpbNKOys7CAre0OoaELytvZEPKaRNJPsVHX6iD-lpEFrtulHhRi7b3oAmL0JMyqGVzrkbDYn0dFm2-2EToCJlQ_9AgDuk5nlIg-850i0BcZ9nRcmkC5owDHr08eTX7iuPC1y_Dz-V501u1IqyhMIcsPmy90p2Df5PbEF0xbU-gO2HhStOsSVtYkvREl39QhvO-PONMATQV1A0l04Cl7DrF-9O7R7c8uXLixsJGrXTXoSoaE6j9jUtgAcbx4KMZabNF_PQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3600",
      "poi_featured_image_media": null,
      "poi_business_url": "https://soulmans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319479301055113754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soulmans-bar-b-que",
      "poi_latitude": "32.8558498",
      "poi_longitude": "-97.2378389",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-479-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17dc-758d-8854-932ceb140b42",
        "storage_key": "property/5737427910000640/019f150e-17dc-758d-8854-932ceb140b42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW25-WAB5ToYRGuoqJSeV96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_63cdb31bf36548638ea251d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "5205 Rufe Snow Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-645e-728c-9358-a2fa54f95675.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-645e-728c-9358-a2fa54f95675",
        "storage_key": "property/5737427910000640/019f150f-645e-728c-9358-a2fa54f95675.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/tx/north-richland-hills/5205-rufe-snow-dr?y_source=1_Mjc5MDUxMTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14981744651422360097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "32.8440718",
      "poi_longitude": "-97.2392025",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35b5-72ec-a6f5-d6021c51feac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35b5-72ec-a6f5-d6021c51feac",
        "storage_key": "property/5737427910000640/019f1510-35b5-72ec-a6f5-d6021c51feac.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ43ExfH15ToYRIWKjP2LZ6c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_f7537d3eced2608db2d54527",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Chuck E. Cheese",
      "poi_type": "Restaurants",
      "poi_address": "7935 Grapevine Hwy, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_long_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-6587-70b1-878f-26c5c95cfbf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-6587-70b1-878f-26c5c95cfbf0",
        "storage_key": "property/5737427910000640/019f150f-6587-70b1-878f-26c5c95cfbf0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chuckecheese.com/n-richland-hills-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4751002506587916196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuck-e-cheese",
      "poi_latitude": "32.8372205",
      "poi_longitude": "-97.2108539",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-498-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4irVuV4ToYRpMcpnJvz7kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_e59b37d7588d3f27a96d4b68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "5152 Rufe Snow Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-7768-745e-aeaf-6f3668f0d16e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7768-745e-aeaf-6f3668f0d16e",
        "storage_key": "property/5737427910000640/019f150f-7768-745e-aeaf-6f3668f0d16e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4675301932234257860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "32.8428632",
      "poi_longitude": "-97.2354999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-479-9711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17ee-712e-a56c-a33b3b8c1df3",
        "storage_key": "property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRGjmUN4ToYRxDWFKFYC4kA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_77520af452d8cb7a85495ca0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "9135 Blvd 26 Ste 250, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-6c83-7222-a6d1-d572c6118cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-6c83-7222-a6d1-d572c6118cbf",
        "storage_key": "property/5737427910000640/019f150f-6c83-7222-a6d1-d572c6118cbf.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/north-richland-hills/the-crossing/035/00582?cid=loc_03500582_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3512040399149941828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.854704",
      "poi_longitude": "-97.1903406",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-605-3392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17ee-712e-a56c-a33b3b8c1df3",
        "storage_key": "property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7MZ5bl4ToYRREQnrCJGvTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_c4d6e46f3bf3fd1304719880",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8532 Davis Blvd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-763d-7378-899e-85147b6123d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-763d-7378-899e-85147b6123d5",
        "storage_key": "property/5737427910000640/019f150f-763d-7378-899e-85147b6123d5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-richland-hills-tx-pharmacies/8532-davis-blvd-north-richland-hills-tx-76182/storeid=16844?WT.mc_id=LS_GOOGLE_RX_16844",
      "poi_directions_map_url": "https://maps.google.com/?cid=469160124573663635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.9076934",
      "poi_longitude": "-97.1882869",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-503-0615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35b0-70d2-a81b-7bb8f3a59d8e",
        "storage_key": "property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2bAbHyPWTYYRk8H9x6XKggY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_5db79e1c57be6d3db6851202",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "6350 Davis Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-7e81-76ee-b0ac-7f4027c40c84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7e81-76ee-b0ac-7f4027c40c84",
        "storage_key": "property/5737427910000640/019f150f-7e81-76ee-b0ac-7f4027c40c84.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6350+davis+blvd-north+richland+hills-tx-76180/id=6631",
      "poi_directions_map_url": "https://maps.google.com/?cid=6114079708713130278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8615379",
      "poi_longitude": "-97.2084957",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-498-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTxAsaZp4ToYRJhlF7hmT2VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2f171f8f67d7d962e53ac3d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "6640 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-77c7-7327-b8f2-1d67fe6138e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-77c7-7327-b8f2-1d67fe6138e3",
        "storage_key": "property/5737427910000640/019f150f-77c7-7327-b8f2-1d67fe6138e3.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/north-richland-hills/6640-ne-loop-820?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1MzItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12610259711389977235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.8391028",
      "poi_longitude": "-97.2394587",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-485-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35bb-76da-91b3-4f4656cf190a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35bb-76da-91b3-4f4656cf190a",
        "storage_key": "property/5737427910000640/019f1510-35bb-76da-91b3-4f4656cf190a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZaYjUZ4ToYRk8rRPmWkAK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_033595aa793b0d58d964660d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "7541 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-77e1-72e8-b1ad-b8d780ecb10a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-77e1-72e8-b1ad-b8d780ecb10a",
        "storage_key": "property/5737427910000640/019f150f-77e1-72e8-b1ad-b8d780ecb10a.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/north-richland-hills/7541-blvd-26?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ0NzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4886735041075474946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.829673",
      "poi_longitude": "-97.221211",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-581-9613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35bb-76da-91b3-4f4656cf190a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35bb-76da-91b3-4f4656cf190a",
        "storage_key": "property/5737427910000640/019f1510-35bb-76da-91b3-4f4656cf190a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVSHa_94ToYRAvLB-qAr0UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_7a342ebb25923c6d8d454c63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "5412 Davis Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-7a85-751f-ab5a-0a58ee252f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7a85-751f-ab5a-0a58ee252f82",
        "storage_key": "property/5737427910000640/019f150f-7a85-751f-ab5a-0a58ee252f82.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/north-richland-hills/5412-davis-boulevard?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5978775491313651146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "32.8472388",
      "poi_longitude": "-97.2134142",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 682-343-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-18fa-774a-bee6-0fbd678d4b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-18fa-774a-bee6-0fbd678d4b6d",
        "storage_key": "property/5737427910000640/019f150e-18fa-774a-bee6-0fbd678d4b6d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAetE3fJ4ToYRys2P56Hg-FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_be5a5ea238827ee1f23a5a59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9101 N Tarrant Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Large chain selling groceries, electronics, furniture, clothing, toys and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-8075-76a9-87b1-332bb40b6a92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-8075-76a9-87b1-332bb40b6a92",
        "storage_key": "property/5737427910000640/019f150f-8075-76a9-87b1-332bb40b6a92.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3274-north-richland-hills-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13700954820705683001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.9058771",
      "poi_longitude": "-97.1892501",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-605-1717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-18fa-774a-bee6-0fbd678d4b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-18fa-774a-bee6-0fbd678d4b6d",
        "storage_key": "property/5737427910000640/019f150e-18fa-774a-bee6-0fbd678d4b6d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbVa-Fm_WTYYROYbWk9GRI74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_36f9aa1ed81fc3d4549d1e73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "DAVIS MART",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 Davis Blvd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-945f-737c-9715-f7891384a948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-945f-737c-9715-f7891384a948",
        "storage_key": "property/5737427910000640/019f150f-945f-737c-9715-f7891384a948.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15965113034292719896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davis-mart",
      "poi_latitude": "32.8707955",
      "poi_longitude": "-97.2074766",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-576-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35fd-7119-a3b5-da3dbdafbc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35fd-7119-a3b5-da3dbdafbc24",
        "storage_key": "property/5737427910000640/019f1510-35fd-7119-a3b5-da3dbdafbc24.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJHTQ2jnx5ToYRGPH5x7d5j90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_8ff0fae171bd346f8df76788",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Holiday Heights Elementary School",
      "poi_type": "Education",
      "poi_address": "5221 Susan Lee Ln, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.birdvilleschools.net/domain/2078",
      "poi_directions_map_url": "https://maps.google.com/?cid=929970214220181380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holiday-heights-elementary-school",
      "poi_latitude": "32.843048",
      "poi_longitude": "-97.2189025",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-547-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8fIufvZ4ToYRhK9Jjvvq5ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_92c95f837e8eb1848f0a95af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Richland Middle School",
      "poi_type": "Education",
      "poi_address": "4801 Redondo St, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-9a26-731c-90f6-0a55edbb88d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-9a26-731c-90f6-0a55edbb88d0",
        "storage_key": "property/5737427910000640/019f150f-9a26-731c-90f6-0a55edbb88d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.birdvilleschools.net/nrchms",
      "poi_directions_map_url": "https://maps.google.com/?cid=9687906655089512095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-middle-school",
      "poi_latitude": "32.8356242",
      "poi_longitude": "-97.2354324",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbbdGtkh4ToYRn87AKcZbcoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_be521a265c3dae819bbe7e0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Richland High School",
      "poi_type": "Education",
      "poi_address": "5201 Holiday Ln, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-95e6-712e-8356-b784f0b33a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-95e6-712e-8356-b784f0b33a06",
        "storage_key": "property/5737427910000640/019f150f-95e6-712e-8356-b784f0b33a06.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://schools.birdvilleschools.net/rhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968800648718811530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-high-school",
      "poi_latitude": "32.842597",
      "poi_longitude": "-97.2299813",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ362XbFx4ToYRioGFxOHcu88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_bcffef136a24d4807f14ed9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "7331 Holiday Ln, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northridgeelementary.birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4449916222299219765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ridge-elementary-school",
      "poi_latitude": "32.8809444",
      "poi_longitude": "-97.2217257",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-547-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2aYXOy3WTYYRNadkPjpHwT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_da9e240fb0cf96d21a4195fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Smithfield Elementary School",
      "poi_type": "Education",
      "poi_address": "8001 Northeast Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-8838-767d-a2c2-f63c4b3eebdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-8838-767d-a2c2-f63c4b3eebdb",
        "storage_key": "property/5737427910000640/019f150f-8838-767d-a2c2-f63c4b3eebdb.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12384686449225711533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smithfield-elementary-school",
      "poi_latitude": "32.8701081",
      "poi_longitude": "-97.2095409",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-547-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ-OuyYJ4ToYRrT-xbLU-36s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a49b1c0c69e06253eaf8b8c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Birdville High School",
      "poi_type": "Education",
      "poi_address": "9100 Mid Cities Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-9efc-7432-9469-5178940ea17c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-9efc-7432-9469-5178940ea17c",
        "storage_key": "property/5737427910000640/019f150f-9efc-7432-9469-5178940ea17c.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.birdvilleschools.net/bhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=17691209623955527921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdville-high-school",
      "poi_latitude": "32.8611675",
      "poi_longitude": "-97.192094",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-547-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu8Ayt7p4ToYR8VjXwmvNg_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_dcebcea8fcd8d43800a08351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Birdville Center of Technology and Advanced Learning",
      "poi_type": "Education",
      "poi_address": "7020 Mid Cities Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-9fbe-7369-901d-deeb3d970835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-9fbe-7369-901d-deeb3d970835",
        "storage_key": "property/5737427910000640/019f150f-9fbe-7369-901d-deeb3d970835.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1561341691854099278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdville-center-of-technology-and-advanced-learning",
      "poi_latitude": "32.8597084",
      "poi_longitude": "-97.2325595",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjUKoVmV4ToYRTpP4E___qhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_99123edbcc5a449ecc1742a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Fort Worth Christian School",
      "poi_type": "Education",
      "poi_address": "6200 Holiday Ln, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-91b0-732a-ae65-19ef4bf02294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-91b0-732a-ae65-19ef4bf02294",
        "storage_key": "property/5737427910000640/019f150f-91b0-732a-ae65-19ef4bf02294.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fwc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14773219327829090647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-christian-school",
      "poi_latitude": "32.8587749",
      "poi_longitude": "-97.2212216",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-520-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ21OAVYh4ToYRVyEw8LQEBc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9456e4d71d32bfc1d8973fd0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Tarrant County College - Northeast Campus",
      "poi_type": "Education",
      "poi_address": "828 W Harwood Rd, Hurst, TX 76054, USA",
      "poi_short_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_long_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-97b1-72c5-adce-12a0ef29ad7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-97b1-72c5-adce-12a0ef29ad7c",
        "storage_key": "property/5737427910000640/019f150d-97b1-72c5-adce-12a0ef29ad7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tccd.edu/locations/northeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601226914742018412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---northeast-campus",
      "poi_latitude": "32.84692560000001",
      "poi_longitude": "-97.1917037",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-TYe8h4ToYRbCHydudEnFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5aefe390ca7914dcd6b09e37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Richland Hills Montessori",
      "poi_type": "Education",
      "poi_address": "8725 N Tarrant Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "School providing daycare, and preschool, elementary, and Montessori education programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-a964-73b7-840b-704c430483a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-a964-73b7-840b-704c430483a1",
        "storage_key": "property/5737427910000640/019f150f-a964-73b7-840b-704c430483a1.webp",
        "width": 1280,
        "height": 729
      },
      "poi_business_url": "http://www.nrhmontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16745002018480462786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hills-montessori",
      "poi_latitude": "32.9052403",
      "poi_longitude": "-97.1973074",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-281-9992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3ftj2jWTYYRwhu68p0yYug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_6a605acaf3aa4a6084f0bd0d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NRH2O Family Water Park",
      "poi_type": "Entertainment",
      "poi_address": "9001 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_long_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-8566-73ad-a9f7-93fce8e39531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8566-73ad-a9f7-93fce8e39531",
        "storage_key": "property/5737427910000640/019f150d-8566-73ad-a9f7-93fce8e39531.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.nrh2o.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1179881649457106072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh2o-family-water-park",
      "poi_latitude": "32.8500662",
      "poi_longitude": "-97.1945008",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-427-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxJqg7h4ToYRmIzk4BvIXxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_c6140c50a961c0765cf955a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Iron Horse Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "6200 Skylark Cir, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Golf course featuring a driving range along with weddings and event hosting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-0aed-735a-9f48-ddb7e100470c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-0aed-735a-9f48-ddb7e100470c",
        "storage_key": "property/5737427910000640/019f150e-0aed-735a-9f48-ddb7e100470c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ironhorsetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331014570284465398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-horse-golf-course",
      "poi_latitude": "32.8358804",
      "poi_longitude": "-97.2543562",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-485-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-18a9-723c-8642-93377ecbeb3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-18a9-723c-8642-93377ecbeb3f",
        "storage_key": "property/5737427910000640/019f150e-18a9-723c-8642-93377ecbeb3f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyfzeC94ToYR9rygYTVI3Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_d785c8478cb183d984ee0ad5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NRH Centre",
      "poi_type": "Entertainment",
      "poi_address": "6000 Hawk Ave, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Clean fitness and aquatic center offering classes, plus a facility for events and parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-a5eb-710b-ba58-1a07fc2f8e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-a5eb-710b-ba58-1a07fc2f8e7d",
        "storage_key": "property/5737427910000640/019f150f-a5eb-710b-ba58-1a07fc2f8e7d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nrhcentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9283738023132317866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh-centre",
      "poi_latitude": "32.8563452",
      "poi_longitude": "-97.1934886",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXZ3RkR4ToYRqsiWcIt21oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_ac91280b25f3c00a50e9d4a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NYTEX Sports Centre",
      "poi_type": "Entertainment",
      "poi_address": "8851 Ice House Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Indoor complex offering ice hockey, including junior-level games, and public skating sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-a2be-71ef-b376-e72a430dcfab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-a2be-71ef-b376-e72a430dcfab",
        "storage_key": "property/5737427910000640/019f150f-a2be-71ef-b376-e72a430dcfab.webp",
        "width": 500,
        "height": 356
      },
      "poi_business_url": "https://www.nytexsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7265013831071379795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nytex-sports-centre",
      "poi_latitude": "32.8597424",
      "poi_longitude": "-97.1965327",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-336-4423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNV3MVbt4ToYRUzFPcZaD0mQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_f22db6962dbb92d4d7bec69c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "AMC Grapevine Mills 24",
      "poi_type": "Entertainment",
      "poi_address": "3150 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Spacious cinema featuring plush seats, state-of-the-art sound and projection systems, and a full menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-b01d-7414-8d84-fffe4e80151d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-b01d-7414-8d84-fffe4e80151d",
        "storage_key": "property/5737427910000640/019f150f-b01d-7414-8d84-fffe4e80151d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/dallas-ft-worth/amc-grapevine-mills-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9818132684599981559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-grapevine-mills-24",
      "poi_latitude": "32.9666895",
      "poi_longitude": "-97.0447697",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 972-539-5909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-360c-7057-9e03-d51f10e5b176.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-360c-7057-9e03-d51f10e5b176",
        "storage_key": "property/5737427910000640/019f1510-360c-7057-9e03-d51f10e5b176.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWpuUIgrTIYR9_U7b6gDQYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6dfda8b8f3370e483c1d9145",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "LEGOLAND® Discovery Center Dallas/Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-aa89-715e-a33c-e29e53067772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-aa89-715e-a33c-e29e53067772",
        "storage_key": "property/5737427910000640/019f150f-aa89-715e-a33c-e29e53067772.webp",
        "width": 701,
        "height": 467
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/dallas-fw/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213318445731368129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-dallasfort-worth",
      "poi_latitude": "32.9666453",
      "poi_longitude": "-97.0434661",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwU71w4YrTIYRwUz7QJyR-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_7e7342f4425ddddf7fb827f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "SEA LIFE Grapevine Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "Grapevine Mills, 3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-afbf-73b3-bf67-ada9f5494e26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-afbf-73b3-bf67-ada9f5494e26",
        "storage_key": "property/5737427910000640/019f150f-afbf-73b3-bf67-ada9f5494e26.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.visitsealife.com/grapevine/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=432349789120866841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-grapevine-aquarium",
      "poi_latitude": "32.9662578",
      "poi_longitude": "-97.0438015",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-3It4YrTIYRGapDr9cDAAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_4e6a586daec6430d10f7fe71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Round1 Bowling & Arcade - Grapevine",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Chain spot featuring bowling, arcade games (including Japan imports), karaoke and a cafe.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c08b-75ca-aab5-46a6dcf5fb53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c08b-75ca-aab5-46a6dcf5fb53",
        "storage_key": "property/5737427910000640/019f150f-c08b-75ca-aab5-46a6dcf5fb53.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://round1usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11587748635949210765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "round1-bowling--arcade---grapevine",
      "poi_latitude": "32.9637845",
      "poi_longitude": "-97.0445353",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 817-873-7981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdiQkoYrTIYRjRxFaP3zz6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_6054b8279666f3cdb468e373",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Palace Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "300 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_long_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-b465-77a8-ba42-c9d25f3a6259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-b465-77a8-ba42-c9d25f3a6259",
        "storage_key": "property/5737427910000640/019f150f-b465-77a8-ba42-c9d25f3a6259.webp",
        "width": 1250,
        "height": 832
      },
      "poi_business_url": "http://www.palace-theatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=760093712415309344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palace-arts-center",
      "poi_latitude": "32.9389638",
      "poi_longitude": "-97.0785253",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 817-410-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4swuDsrTIYRIL6FTDRljAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_0d4275850b64488caf94d02a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Third Rail Bar + Events",
      "poi_type": "Entertainment",
      "poi_address": "Inside Harvest Hall, 815 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c089-7586-a3de-41b85f31e9ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c089-7586-a3de-41b85f31e9ab",
        "storage_key": "property/5737427910000640/019f150f-c089-7586-a3de-41b85f31e9ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://harvesthall.com/events",
      "poi_directions_map_url": "https://maps.google.com/?cid=9957415667515274083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "third-rail-bar--events",
      "poi_latitude": "32.9333051",
      "poi_longitude": "-97.0772408",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-251-3069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZjghXQrTIYRYzMo_8rYL4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_4c8caa3e1350dc4f238a973e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Medical City North Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Booth Calloway Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-b8e1-77bc-b9e2-051a2c998716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b8e1-77bc-b9e2-051a2c998716",
        "storage_key": "property/5737427910000640/019f150d-b8e1-77bc-b9e2-051a2c998716.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-north-hills-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15705034484950082842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-north-hills",
      "poi_latitude": "32.8291892",
      "poi_longitude": "-97.2135735",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-255-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1830-722d-985f-6d17bd08c3d9",
        "storage_key": "property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-eO_Px4ToYRGqW1vKd989k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_fdd6b90759c1ed687cdeca0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Methodist Legacy ER & Urgent Care - North Richland Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "8950 N Tarrant Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c4be-76ae-99b0-8ed737068405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c4be-76ae-99b0-8ed737068405",
        "storage_key": "property/5737427910000640/019f150f-c4be-76ae-99b0-8ed737068405.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eruc.methodisthealthsystem.org/locations/north-richland-hills/?utm_source=loclistings&utm_medium=organic&y_source=1_MTA1MTk2OTMzNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10268558790194552819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-legacy-er--urgent-care---north-richland-hills",
      "poi_latitude": "32.9031661",
      "poi_longitude": "-97.1933073",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-281-7277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDb8WHW_WTYYR89_ChNA_gY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_a92edb5704eb4ab5a6c6ea27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - North Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "6401 NE Loop 820 Ste 200, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-b850-762b-a1f2-1bf2840c73db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-b850-762b-a1f2-1bf2840c73db",
        "storage_key": "property/5737427910000640/019f150f-b850-762b-a1f2-1bf2840c73db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/north-hills?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9056268153368588389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---north-hills",
      "poi_latitude": "32.8426996",
      "poi_longitude": "-97.2464456",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-893-1630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWWnjyZ5ToYRZbA3QOdTrn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_38d5bda164c8bba0cc355612",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Glenview Professional Pharmacy Inc",
      "poi_type": "Health and Wellness",
      "poi_address": "7640 Glenview Dr Suite D, Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-bf4a-74fc-b652-b867deaa891a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-bf4a-74fc-b652-b867deaa891a",
        "storage_key": "property/5737427910000640/019f150f-bf4a-74fc-b652-b867deaa891a.webp",
        "width": 900,
        "height": 340
      },
      "poi_business_url": "http://www.glenviewrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16237099993643362742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenview-professional-pharmacy-inc",
      "poi_latitude": "32.8233991",
      "poi_longitude": "-97.2132672",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-284-1489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35b0-70d2-a81b-7bb8f3a59d8e",
        "storage_key": "property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxe6oUQJ5ToYRtimcl2rEVeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ad79a9e4fb37fa4737910946",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Health and Wellness",
      "poi_address": "7201 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c84a-76dc-b0c4-950fefc39640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c84a-76dc-b0c4-950fefc39640",
        "storage_key": "property/5737427910000640/019f150f-c84a-76dc-b0c4-950fefc39640.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/north-richland-hills/greater-richland-plaza/035/00807?cid=loc_03500807_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10371558215078564795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.82485339999999",
      "poi_longitude": "-97.2277449",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-281-4007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17ee-712e-a56c-a33b3b8c1df3",
        "storage_key": "property/5737427910000640/019f150e-17ee-712e-a56c-a33b3b8c1df3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi93HqlR4ToYRu9MK6T4t748",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_735ed93048a37f3ca02daf9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7200 Blvd 26, Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c0db-75de-960b-f8404dd642cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c0db-75de-960b-f8404dd642cd",
        "storage_key": "property/5737427910000640/019f150f-c0db-75de-960b-f8404dd642cd.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richland-hills-tx-pharmacies/7200-boulevard-26-corner-of-glenview-richland-hills-tx-76180/storeid=7628?WT.mc_id=LS_GOOGLE_RX_7628",
      "poi_directions_map_url": "https://maps.google.com/?cid=12078385719104978089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8241272",
      "poi_longitude": "-97.2263494",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-284-3469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35b0-70d2-a81b-7bb8f3a59d8e",
        "storage_key": "property/5737427910000640/019f1510-35b0-70d2-a81b-7bb8f3a59d8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-ayQat5ToYRqTxnR9ELn6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4c2fcbe346f4bf60f87e8f22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Movement Theory Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "6350 Glenview Dr Unit 106, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c966-762b-8a6b-e84e388f1137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c966-762b-8a6b-e84e388f1137",
        "storage_key": "property/5737427910000640/019f150f-c966-762b-8a6b-e84e388f1137.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://movementtheoryfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700016452328381639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movement-theory-fitness-club",
      "poi_latitude": "32.8237809",
      "poi_longitude": "-97.2477049",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-520-6406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8_EroN5ToYRx1zS-Mep4dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_55c13c0b9924607011189d2e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NRH Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 Hawk Ave, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Clean fitness and aquatic center offering classes, plus a facility for events and parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-a5eb-710b-ba58-1a07fc2f8e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-a5eb-710b-ba58-1a07fc2f8e7d",
        "storage_key": "property/5737427910000640/019f150f-a5eb-710b-ba58-1a07fc2f8e7d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nrhcentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9283738023132317866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh-centre",
      "poi_latitude": "32.8563452",
      "poi_longitude": "-97.1934886",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXZ3RkR4ToYRqsiWcIt21oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_89a84b361f22ba9a08b09d96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "CrossFit OTL",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 Blvd 26 #270, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Functional-movement, group fitness programs offered at a friendly facility with experienced coaches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-c8b5-72e2-8d1b-2983bba9b45f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-c8b5-72e2-8d1b-2983bba9b45f",
        "storage_key": "property/5737427910000640/019f150f-c8b5-72e2-8d1b-2983bba9b45f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://crossfit-otl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9913341474191288720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-otl",
      "poi_latitude": "32.8559405",
      "poi_longitude": "-97.18805",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-662-2788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92qCYXd5ToYRkKlRMoxDk4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_fe04d6b1b012a75f8418e1ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Shine Pole & Aerial Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "8535 Airport Fwy #200, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-cc2a-7303-b8e7-ca8f3275a926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-cc2a-7303-b8e7-ca8f3275a926",
        "storage_key": "property/5737427910000640/019f150f-cc2a-7303-b8e7-ca8f3275a926.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.shinefitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14792253661584629221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shine-pole--aerial-fitness-studio",
      "poi_latitude": "32.8358329",
      "poi_longitude": "-97.2014739",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-756-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-Q-S1h_ToYR5R05HlWkSM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_3facac061d28c413cc4b688d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "The Lakes at HomeTown",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8700 Bridge St, North Richland Hills, TX 76180, USA",
      "poi_short_description": "City park offering walking trails, fishing, and other kid-friendly recreational pursuits.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-cd0d-73f9-a840-7a02aff815b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-cd0d-73f9-a840-7a02aff815b5",
        "storage_key": "property/5737427910000640/019f150f-cd0d-73f9-a840-7a02aff815b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nrhtx.com/Facilities.aspx?Page=detail&RID=33",
      "poi_directions_map_url": "https://maps.google.com/?cid=8084186867968591643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-lakes-at-hometown",
      "poi_latitude": "32.8537161",
      "poi_longitude": "-97.1989179",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-427-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4aLBm714ToYRG0cl4x_NMHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_822d9a92e3914b33a8c13e65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Walker's Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8403 Emerald Hills Way, North Richland Hills, TX 76180, USA",
      "poi_short_description": "City park featuring baseball and softball fields, a walking trail, and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-cbd4-73dd-a844-ef50a8368a2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-cbd4-73dd-a844-ef50a8368a2c",
        "storage_key": "property/5737427910000640/019f150f-cbd4-73dd-a844-ef50a8368a2c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.nrhtx.com/Facilities/Facility/Details/27",
      "poi_directions_map_url": "https://maps.google.com/?cid=11469990340986163135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walkers-creek-park",
      "poi_latitude": "32.8503726",
      "poi_longitude": "-97.2011947",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcXPeW5V4ToYRv0-ky3GXLZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_aa740c57cd7ad1568e3c5b9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NRH2O Family Water Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9001 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_long_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-8566-73ad-a9f7-93fce8e39531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8566-73ad-a9f7-93fce8e39531",
        "storage_key": "property/5737427910000640/019f150d-8566-73ad-a9f7-93fce8e39531.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.nrh2o.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1179881649457106072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh2o-family-water-park",
      "poi_latitude": "32.8500662",
      "poi_longitude": "-97.1945008",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-427-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxJqg7h4ToYRmIzk4BvIXxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_a201c65fdc29198555d4089e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Iron Horse Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6200 Skylark Cir, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Golf course featuring a driving range along with weddings and event hosting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-0aed-735a-9f48-ddb7e100470c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-0aed-735a-9f48-ddb7e100470c",
        "storage_key": "property/5737427910000640/019f150e-0aed-735a-9f48-ddb7e100470c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ironhorsetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331014570284465398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-horse-golf-course",
      "poi_latitude": "32.8358804",
      "poi_longitude": "-97.2543562",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-485-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-18a9-723c-8642-93377ecbeb3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-18a9-723c-8642-93377ecbeb3f",
        "storage_key": "property/5737427910000640/019f150e-18a9-723c-8642-93377ecbeb3f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyfzeC94ToYR9rygYTVI3Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_7e2cea306ec8a28b446fe742",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Adventure World Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7451 Starnes Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Open green space with a community-built playground for kids, plus walking trails & picnic tables.",
      "poi_long_description": "Open green space with a community-built playground for kids, plus walking trails & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-ddba-7764-8439-52f3f5deb677.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ddba-7764-8439-52f3f5deb677",
        "storage_key": "property/5737427910000640/019f150d-ddba-7764-8439-52f3f5deb677.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=4653781666082864085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-world-playground",
      "poi_latitude": "32.8829808",
      "poi_longitude": "-97.2215997",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2Fqm8zXTYYR1TsYvcSNlUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ba541fd1290e724cf8805322",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Northfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7804 Davis Blvd, Northfield Pk Trl, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Park featuring basketball and baseball fields along with sand volleyball courts, tennis courts and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-d4bc-7053-9304-8a68fcf40e47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-d4bc-7053-9304-8a68fcf40e47",
        "storage_key": "property/5737427910000640/019f150f-d4bc-7053-9304-8a68fcf40e47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836581513159326627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northfield-park",
      "poi_latitude": "32.8908062",
      "poi_longitude": "-97.1985596",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9doshXWTYYRozsJEMWOgog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_64eece437d2a46cf7102403b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "NRH Tipps Canine Hollow Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7804 Davis Blvd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Spacious dog park with separate areas for big and small pooches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-d4c0-7187-bf47-aba31d6f6c96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-d4c0-7187-bf47-aba31d6f6c96",
        "storage_key": "property/5737427910000640/019f150f-d4c0-7187-bf47-aba31d6f6c96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nrhtx.com/Facilities.aspx?Page=detail&RID=16",
      "poi_directions_map_url": "https://maps.google.com/?cid=5412212991175099589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh-tipps-canine-hollow-dog-park",
      "poi_latitude": "32.8900077",
      "poi_longitude": "-97.2011592",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYB-Fj7WTYYRxQS_UwoLHEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_d2e2d617a41b561eab59ca84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Cross Timbers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7680 Douglas Ln, North Richland Hills, TX 76182, USA",
      "poi_short_description": "City park with picnic tables and a playground, plus ball fields, trails, and a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-d4b9-7024-ad3e-d289fa182e14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-d4b9-7024-ad3e-d289fa182e14",
        "storage_key": "property/5737427910000640/019f150f-d4b9-7024-ad3e-d289fa182e14.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/12",
      "poi_directions_map_url": "https://maps.google.com/?cid=15955886341334589825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cross-timbers-park",
      "poi_latitude": "32.887894",
      "poi_longitude": "-97.228875",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SNiR8nXTYYRgWHB6xaybt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_b5f947ae84a39f445f3b2a8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Linda Spurlock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6400 Glenview Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Community park featuring a kids' playground, walking/jogging trail, open fields & a pond.",
      "poi_long_description": "Community park featuring a kids' playground, walking/jogging trail, open fields & a pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-d8c2-77fa-b90a-512d5a939108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-d8c2-77fa-b90a-512d5a939108",
        "storage_key": "property/5737427910000640/019f150f-d8c2-77fa-b90a-512d5a939108.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/23",
      "poi_directions_map_url": "https://maps.google.com/?cid=9382430612010663564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linda-spurlock-park",
      "poi_latitude": "32.8212662",
      "poi_longitude": "-97.2459896",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-590-8049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0ht1Mp5ToYRjH6lbu4WNYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c127046dcaf2a7a81486bfc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Fossil Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Richland Hills, TX 76117, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-dd6c-7100-bd00-cf1ac08a3232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-dd6c-7100-bd00-cf1ac08a3232",
        "storage_key": "property/5737427910000640/019f150f-dd6c-7100-bd00-cf1ac08a3232.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1880299471274250292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fossil-creek-park",
      "poi_latitude": "32.8156006",
      "poi_longitude": "-97.2539205",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1844-725d-b069-594002ba628c",
        "storage_key": "property/5737427910000640/019f150e-1844-725d-b069-594002ba628c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfWQNM55ToYRNBCoKGgqGBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_48716b63877a19b18ac3109c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Richland Hills/Iron Horse Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-dc2a-738a-9b3c-b561c168bf48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-dc2a-738a-9b3c-b561c168bf48",
        "storage_key": "property/5737427910000640/019f150f-dc2a-738a-9b3c-b561c168bf48.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5631713715274185447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillsiron-horse-station",
      "poi_latitude": "32.8447652",
      "poi_longitude": "-97.2494671",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWX3dj54ToYR5_qcM8ndJ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "ec_d6e683cb70e5339caf98d5e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Richland Hills/Smithfield TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6420 Smithfield Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-d479-743e-a4a5-1883566112cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-d479-743e-a4a5-1883566112cf",
        "storage_key": "property/5737427910000640/019f150f-d479-743e-a4a5-1883566112cf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/north-richland-hills-smithfield-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17453827278972292890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillssmithfield-texrail-station",
      "poi_latitude": "32.8640386",
      "poi_longitude": "-97.2116058",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQM5-j55ToYRGo8qlm9zOPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_97d2c693f2de827f252ca764",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Cavalli at Iron Horse Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6490 Iron Horse Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-db09-71ce-a551-7ba82afefd59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-db09-71ce-a551-7ba82afefd59",
        "storage_key": "property/5737427910000640/019f150f-db09-71ce-a551-7ba82afefd59.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lifeatcavalli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3483435975894091319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cavalli-at-iron-horse-station",
      "poi_latitude": "32.8467397",
      "poi_longitude": "-97.2445953",
      "poi_miles_from_property": "322 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-904-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e0KvWV5ToYRN8b7ZJCmVzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_e6dd05a264d942470522a5da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-dafb-748f-b957-b2b680f2435a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-dafb-748f-b957-b2b680f2435a",
        "storage_key": "property/5737427910000640/019f150f-dafb-748f-b957-b2b680f2435a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35bf-7527-8263-a424e79a9be2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35bf-7527-8263-a424e79a9be2",
        "storage_key": "property/5737427910000640/019f1510-35bf-7527-8263-a424e79a9be2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_23783eae35514accbb4f6a93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e201-71ff-b08e-c1fe977a6b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e201-71ff-b08e-c1fe977a6b99",
        "storage_key": "property/5737427910000640/019f150f-e201-71ff-b08e-c1fe977a6b99.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1afc-774c-8433-30522b608995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1afc-774c-8433-30522b608995",
        "storage_key": "property/5737427910000640/019f150e-1afc-774c-8433-30522b608995.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_21611686ee606dbcd1c3f989",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Fort Worth T&p",
      "poi_type": "Transportation & Transit",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e0dd-722e-baf3-e712cae33a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e0dd-722e-baf3-e712cae33a83",
        "storage_key": "property/5737427910000640/019f150f-e0dd-722e-baf3-e712cae33a83.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/fort-worth-tp-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2586634399591785905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-tp",
      "poi_latitude": "32.7453226",
      "poi_longitude": "-97.3279067",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1afc-774c-8433-30522b608995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1afc-774c-8433-30522b608995",
        "storage_key": "property/5737427910000640/019f150e-1afc-774c-8433-30522b608995.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TtRaxNxToYRsWV5J0iS5SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_2deccf9d42421d5b049e66be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Mercantile Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4233 N Beach St, Fort Worth, TX 76137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e537-704d-8ed1-1d2c9e99f515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e537-704d-8ed1-1d2c9e99f515",
        "storage_key": "property/5737427910000640/019f150f-e537-704d-8ed1-1d2c9e99f515.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8576246469015309317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercantile-center-station",
      "poi_latitude": "32.8195149",
      "poi_longitude": "-97.2933422",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSZcvQl3ToYRBQzbg7nyBHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_51119d9d0423817efe1b4399",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Tarrant County College - Northeast Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "828 W Harwood Rd, Hurst, TX 76054, USA",
      "poi_short_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_long_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-97b1-72c5-adce-12a0ef29ad7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-97b1-72c5-adce-12a0ef29ad7c",
        "storage_key": "property/5737427910000640/019f150d-97b1-72c5-adce-12a0ef29ad7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tccd.edu/locations/northeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601226914742018412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---northeast-campus",
      "poi_latitude": "32.84692560000001",
      "poi_longitude": "-97.1917037",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-TYe8h4ToYRbCHydudEnFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_86780ec0edb8b4a02075649c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e4e6-776b-b36e-f0b8b59cb8c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e4e6-776b-b36e-f0b8b59cb8c6",
        "storage_key": "property/5737427910000640/019f150f-e4e6-776b-b36e-f0b8b59cb8c6.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1830-722d-985f-6d17bd08c3d9",
        "storage_key": "property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_e59670429a4b692ad9363f93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Birdville Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e679-7059-9191-a69036526fd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e679-7059-9191-a69036526fd3",
        "storage_key": "property/5737427910000640/019f150f-e679-7059-9191-a69036526fd3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13928350146308917447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdville-independent-school-district",
      "poi_latitude": "32.8610689",
      "poi_longitude": "-97.1918977",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-547-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17d0-7719-ae65-781fe940bd5c",
        "storage_key": "property/5737427910000640/019f150e-17d0-7719-ae65-781fe940bd5c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQec6pdx5ToYRx8gAmqlwS8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_5b4900e6c557005a91445c3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "North Richland Hills City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 City Point Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e7e6-7358-976c-53f710e60078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e7e6-7358-976c-53f710e60078",
        "storage_key": "property/5737427910000640/019f150f-e7e6-7358-976c-53f710e60078.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nrhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17726973294756893019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hills-city-hall",
      "poi_latitude": "32.8269764",
      "poi_longitude": "-97.2177788",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-427-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1b0d-7107-b134-1b11749ccd6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1b0d-7107-b134-1b11749ccd6d",
        "storage_key": "property/5737427910000640/019f150e-1b0d-7107-b134-1b11749ccd6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg54ft1l4ToYRWxHSQErcAvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_d7888813a81d749dab656701",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Perot Field Fort Worth Alliance Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13901 Aviator Way Suite 270, Fort Worth, TX 76177, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e7ff-726c-a564-5bd459d64fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e7ff-726c-a564-5bd459d64fd7",
        "storage_key": "property/5737427910000640/019f150f-e7ff-726c-a564-5bd459d64fd7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.perotfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5088778947380879429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perot-field-fort-worth-alliance-airport",
      "poi_latitude": "32.9852708",
      "poi_longitude": "-97.3130348",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 817-890-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f1510-35bf-7527-8263-a424e79a9be2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-35bf-7527-8263-a424e79a9be2",
        "storage_key": "property/5737427910000640/019f1510-35bf-7527-8263-a424e79a9be2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJTxYZ9rHbTYYRRaAfu335nkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_f9eb3368d55c2f196b064780",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hospital Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10864 Texas Health Trail, Fort Worth, TX 76244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-e790-776b-826f-317e18d072d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-e790-776b-826f-317e18d072d7",
        "storage_key": "property/5737427910000640/019f150f-e790-776b-826f-317e18d072d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-alliance",
      "poi_directions_map_url": "https://maps.google.com/?cid=17092132446099404857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hospital-alliance",
      "poi_latitude": "32.9306831",
      "poi_longitude": "-97.3098139",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 682-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1830-722d-985f-6d17bd08c3d9",
        "storage_key": "property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdk06grZTYYROfiu1-ZzM-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_37eafba8d122fa762e53725c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "Medical City Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3101 N Tarrant Pkwy, Fort Worth, TX 76177, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-bf24-70dc-865a-8ef395b3cf17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-bf24-70dc-865a-8ef395b3cf17",
        "storage_key": "property/5737427910000640/019f150d-bf24-70dc-865a-8ef395b3cf17.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-alliance-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640058057365368600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-alliance",
      "poi_latitude": "32.899942",
      "poi_longitude": "-97.3138893",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-639-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1830-722d-985f-6d17bd08c3d9",
        "storage_key": "property/5737427910000640/019f150e-1830-722d-985f-6d17bd08c3d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb7q8vnYTYYRGK8Pb4QVhDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_3629ef6ee1a28b957a52d231",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 31 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_c34c65d8667b3ca0a830e1de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "BNSF Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Intermodal Pkwy, Haslet, TX 76052, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-ea50-712d-97d4-7fc054d6a5fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-ea50-712d-97d4-7fc054d6a5fa",
        "storage_key": "property/5737427910000640/019f150f-ea50-712d-97d4-7fc054d6a5fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13417799383903264155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bnsf-alliance",
      "poi_latitude": "32.9901049",
      "poi_longitude": "-97.3497045",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QV-kobbTYYRm10C-XKZNbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f120921100fdf31d595b5f02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "poi_name": "FedEx Supply Chain",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5201 Alliance Gateway Fwy, Fort Worth, TX 76177, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-ebe3-77bb-a15c-c46cf74ab455.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-ebe3-77bb-a15c-c46cf74ab455",
        "storage_key": "property/5737427910000640/019f150f-ebe3-77bb-a15c-c46cf74ab455.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14117901946252762738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fedex-supply-chain",
      "poi_latitude": "32.9871367",
      "poi_longitude": "-97.2509117",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 817-491-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-17da-76ab-b99e-50ffcde51268",
        "storage_key": "property/5737427910000640/019f150e-17da-76ab-b99e-50ffcde51268.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoRuqMZHQTYYRch4xMAXd7MM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_48b795a0-561f-468f-930d-527301eddfb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1c2edff3-ff05-4d98-9bf7-8dd4615b15e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d064113f-a5e0-4651-b523-92d95c9349b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ea452616-5195-4158-b127-1521a46a0b04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_082830c8-c2e5-42b6-ad29-cdc5c910e7e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_e9a6a7da-e282-4745-8111-41fc85ee7d2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_74cd6761204c8186eb6ffd19",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "rating": "5",
      "name": "Lauren Bradshaw",
      "text": "Idk if this will be my new place of residency yet I'm hoping but only time will tell. I did want to give an amazing shout out to the property and staff as I toured today. Aleca was such a delight! She was personable and my tour was everything. The amenities are spectacular truly and if I do make this my place of residency I definitely plan on bragging about my experience as a resident. This property is 10 mins from my job versus the 45 min commute one way im making daily is a bonus. The property was clean and very presentable. She knew a resident that came in by name and addressed her as such. It truly was an experience! If you have time stop by. I do have one request, granted I'm not sure if its marketing purposes but I wish they had the videos online to show my sister and boyfriend but I guess they can just come tour with me but thats the only downfall.",
      "date": "2026-04-22",
      "title": "false"
    },
    {
      "id": "ec_cde08e7a7cee7b6ce7606495",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "rating": "5",
      "name": "Patrick Womack",
      "text": "Been living here since January of 2022. Its a very nice, clean community. Anytime there's an issue, staff and maintenance (if necessary) are always right on top of it. The current staff has been very nice anytime I've seen them. Most times when I call with an issue or question, it's been Tiffany that answers. She has always been very accommodating and helpful!",
      "date": "2026-01-22",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_6d9bbef2123d2e8e8e7084ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f14c4-9a89-7279-bc63-d7ac02e3df53.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-9a89-7279-bc63-d7ac02e3df53",
        "storage_key": "property/5737427910000640/019f14c4-9a89-7279-bc63-d7ac02e3df53.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Cavalli at Iron Horse Station - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/1Aar5PWoRYg"
    }
  ],
  "faqs": [
    {
      "id": "custom_4b98e9bb-af5f-4777-9539-62dcb1be467f",
      "question": "Is Cavalli at Iron Horse Station pet-friendly?",
      "answer": "Yes. Cavalli at Iron Horse Station welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. A pet deposit of $300 applies. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (469) 892-7100 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_b6eabca3-9f35-49b7-90f5-f658fe0382b8",
      "question": "How can I schedule a tour at Cavalli at Iron Horse Station?",
      "answer": "You can schedule a tour of Cavalli at Iron Horse Station online through our Schedule a Tour page, or call the leasing office at (469) 892-7100. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_8d20979e-40e4-4efc-bc7c-9e8c045bd9f0",
      "question": "What are the leasing office hours at Cavalli at Iron Horse Station?",
      "answer": "The Cavalli at Iron Horse Station leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (469) 892-7100 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_d1db282f-40ab-4a82-ae62-3376c5505346",
      "question": "What floor plans are available at Cavalli at Iron Horse Station?",
      "answer": "Cavalli at Iron Horse Station offers 1- to 3-bedroom apartment homes ranging from approximately 605 to 1,298 square feet, across 11 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_5fa54699-2e14-4fea-8bd5-02a15d735985",
      "question": "What amenities does Cavalli at Iron Horse Station have?",
      "answer": "Cavalli at Iron Horse Station offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, *Coming Soon, Access Gates, American Landmark 360, Car Charging Stations, Covered Parking, Dog Park, Game Room, Online Resident Services, Pool, Storage Spaces, BBQ, Lounge, Resident Convenience Store, and Yoga/Flex Studio. In-home features include: cabinets, fenced yard, french doors, garden tub, hard floors, kitchen appliances, outside space, select homes, tall ceilings, usb outlet, and w&d included. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_52fc7848-97f5-4796-9d49-0e7d5c3f0678",
      "question": "Where is Cavalli at Iron Horse Station located?",
      "answer": "Cavalli at Iron Horse Station is located at 6490 Iron Horse Blvd, North Richland Hills TX 76180. Nearby you'll find dining at Mi Pueblo, shopping at WinCo Foods, and green space at The Lakes at HomeTown. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_d30189af-2b22-4b68-be7e-f52c95a7061d",
      "question": "How do I apply to live at Cavalli at Iron Horse Station?",
      "answer": "You can apply to live at Cavalli at Iron Horse Station online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (469) 892-7100 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_3718157a-602d-481f-b89d-6f4154af1ff4",
      "question": "What do I need to apply at Cavalli at Iron Horse Station?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Cavalli at Iron Horse Station leasing team at (469) 892-7100 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_165f3510-c96d-4ea3-adb3-066a67258bc2",
      "question": "What is the Landmark 360 program at Cavalli at Iron Horse Station?",
      "answer": "Cavalli at Iron Horse Station participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (469) 892-7100 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_4293e49c-1a21-40da-8a25-6ae7a41534aa",
      "question": "Does Cavalli at Iron Horse Station have a pool?",
      "answer": "Yes. Cavalli at Iron Horse Station has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ef9c43a2-76ff-4f02-9b5b-ef5ac46576ff",
      "question": "Does Cavalli at Iron Horse Station have a dog park?",
      "answer": "Yes. Cavalli at Iron Horse Station has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_35339159-87e3-4947-a405-8abd50e1bc2e",
      "question": "Does Cavalli at Iron Horse Station offer virtual tours?",
      "answer": "Yes. Cavalli at Iron Horse Station offers virtual tours of Cavalli at Iron Horse Station - Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_f77d8acc-8f8a-42e3-9c5c-e036b435d9cb",
      "question": "What do residents say about living at Cavalli at Iron Horse Station?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Cavalli at Iron Horse Station. One resident wrote: *\"Been living here since January of 2022. Its a very nice, clean community. Anytime there's an issue, staff and maintenance (if necessary) are always right on top of it. The current staff has been very nice anytime I've seen them.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_5303d165-a8fe-4018-9cce-ebc635546ae2",
      "question": "When was Cavalli at Iron Horse Station built?",
      "answer": "Cavalli at Iron Horse Station was built in 2021. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_6379caec-3f6e-48db-9646-41fb0a03b61d",
      "question": "What is the pet fee at Cavalli at Iron Horse Station?",
      "answer": "Pets at Cavalli at Iron Horse Station: cats and dogs are welcome, up to 2 per home, with no posted weight limit. A pet deposit of $300 applies. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (469) 892-7100 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_90203560-40f7-4370-bebb-c6d2f436f977",
      "question": "What features are included in the apartments at Cavalli at Iron Horse Station?",
      "answer": "Apartment homes at Cavalli at Iron Horse Station include cabinets, fenced yard, french doors, garden tub, hard floors, kitchen appliances, outside space, select homes, tall ceilings, usb outlet, and w&d included. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_c2635e17-aab4-4f02-81fb-449bdd95b3bd",
      "question": "What restaurants and shops are near Cavalli at Iron Horse Station?",
      "answer": "Nearby restaurants and shops include Mi Pueblo, Olive Garden Italian Restaurant, Ernie's Seafood Restaurant, and Japan House. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-5128-76b9-a7ae-e0b93287d5a0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cavalli-at-iron-horse-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640"
    },
    {
      "lead_collector_id": "0198aa45-518c-73ff-a3b6-e0ea44d6858d",
      "lead_source": "FACEBOOK_ADS",
      "name": "cavalli-at-iron-horse-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640"
    },
    {
      "lead_collector_id": "0198aa45-51f0-76fe-bcb9-3890d6ce70ef",
      "lead_source": "LANDING_PAGE",
      "name": "cavalli-at-iron-horse-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "studio-apartments-for-rent-north-richland-hills-tx",
      "search_query": "Studio Apartments For Rent In North Richland Hills TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments For Rent In North Richland Hills TX",
      "h2_subtitle": "Discover luxury living at Cavalli at Iron Horse Station. Our studio apartments offer upscale amenities and a prime location.",
      "page_copy": "Experience the best in studio apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Our community features a range of upscale amenities, including a state-of-the-art Fitness Center, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Enjoy leisure time in our Community Game Room or unwind by the resort-style swimming pool with poolside cabanas. Each studio apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station offers the perfect blend of convenience and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "<p class=\"rteBlock\">Cavalli at Iron Horse Station | Studio Apartments in North Richland Hills, TX</p>",
      "seo_description": "Discover luxury studio apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-north-richland-hills",
      "search_query": "One Bedroom Apartments For Rent In North Richland Hills TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In North Richland Hills TX",
      "h2_subtitle": "Elevate your lifestyle at Cavalli at Iron Horse Station. Our one-bedroom apartments offer modern amenities and a prime location.",
      "page_copy": "Discover the perfect one bedroom apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Our community features a variety of upscale amenities, including a state-of-the-art Fitness Center, a serene Yoga Studio, and Well Beats virtual fitness classes. Enjoy socializing in our Community Game Room or relax by the resort-style swimming pool with poolside cabanas. Each one-bedroom apartment is thoughtfully designed with features like stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "<p class=\"rteBlock\">Cavalli at Iron Horse Station | One Bedroom Apartments For Rent In North Richland Hills, TX</p>",
      "seo_description": "Find luxury one bedroom apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Modern amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-north-richland-hills-tx",
      "search_query": "Two Bedrooms Apartments For Rent In North Richland Hills TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In North Richland Hills TX",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our two-bedroom apartments offer modern amenities and a prime location.",
      "page_copy": "Explore the finest two bedrooms apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Our community features a range of upscale amenities, including a state-of-the-art Fitness Center, a tranquil Yoga Studio, and Well Beats virtual fitness classes. Enjoy leisure activities in our Community Game Room or relax by the resort-style swimming pool with poolside cabanas. Each two-bedroom apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station offers the perfect blend of luxury and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "<p class=\"rteBlock\">Cavalli at Iron Horse Station | Two Bedrooms Apartments For Rent In North Richland Hills, TX</p>",
      "seo_description": "Discover luxury two bedrooms apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Modern amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-north-richland-hills",
      "search_query": "Three Bedrooms Apartments For Rent In North Richland Hills TX",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In North Richland Hills TX",
      "h2_subtitle": "Indulge in luxury living at Cavalli at Iron Horse Station. Our three-bedroom apartments offer upscale amenities and a prime location.",
      "page_copy": "Discover the ultimate in three bedrooms apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Our community features a variety of upscale amenities, including a state-of-the-art Fitness Center, a serene Yoga Studio, and Well Beats virtual fitness classes. Enjoy socializing in our Community Game Room or unwind by the resort-style swimming pool with poolside cabanas. Each three-bedroom apartment is thoughtfully designed with features like stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "<p class=\"rteBlock\">Cavalli at Iron Horse Station | Three Bedrooms Apartments For Rent In North Richland Hills, TX</p>",
      "seo_description": "Find luxury three bedrooms apartments for rent in North Richland Hills TX at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resort-style-pool",
      "search_query": "Apartments For Rent Near Me with Resort-Style Swimming Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Style Swimming Pool",
      "h2_subtitle": "Enjoy luxury living at Cavalli at Iron Horse Station. Our apartments feature a resort-style swimming pool and a range of upscale amenities.",
      "page_copy": "Discover the best apartments for rent near me with resort-style swimming pool at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent Near Me with Resort-Style Swimming Pool",
      "seo_description": "Find luxury apartments for rent near me with resort-style swimming pool at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resident-game-room",
      "search_query": "Apartments For Rent Near Me with Resident Game room w/ Foosball",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resident Game room w/ Foosball",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments feature a resident game room with foosball and a range of upscale amenities.",
      "page_copy": "Discover the finest apartments for rent near me with resident game room w/ foosball at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent Near Me with Resident Game room w/ Foosball",
      "seo_description": "Find luxury apartments for rent near me with resident game room w/ foosball at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resident-picnic-bbq-area",
      "search_query": "Apartments For Rent Near Me with Resident Picnic & Barbeque Area",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resident Picnic & Barbeque Area",
      "h2_subtitle": "Enjoy luxury living at Cavalli at Iron Horse Station. Our apartments feature a resident picnic & barbeque area and a range of upscale amenities.",
      "page_copy": "Discover the best apartments for rent near me with resident picnic & barbeque area at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent Near Me with Resident Picnic & Barbeque Area",
      "seo_description": "Find luxury apartments for rent near me with resident picnic & barbeque area at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-private-patios-balconies",
      "search_query": "Apartments For Rent Near Me with Private Patios or Balconies",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Private Patios or Balconies",
      "h2_subtitle": "Enjoy luxury living at Cavalli at Iron Horse Station. Our apartments feature private patios or balconies and a range of upscale amenities.",
      "page_copy": "Discover the best apartments for rent near me with private patios or balconies at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent Near Me with Private Patios or Balconies",
      "seo_description": "Find luxury apartments for rent near me with private patios or balconies at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-custom-light-fixtures",
      "search_query": "Apartments For Rent Near Me with 9' Ceilings w/ Custom Light Fixtures*",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 9' Ceilings w/ Custom Light Fixtures*",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments feature 9' ceilings w/ custom light fixtures* and a range of upscale amenities.",
      "page_copy": "Discover the finest apartments for rent near me with 9' ceilings w/ custom light fixtures* at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located near Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent Near Me with 9' Ceilings w/ Custom Light Fixtures*",
      "seo_description": "Find luxury apartments for rent near me with 9' ceilings w/ custom light fixtures* at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-texas-health",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Texas Health Harris Methodist Hospital Alliance",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Texas Health Harris Methodist Hospital Alliance",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Texas Health Harris Methodist Hospital Alliance.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Texas Health Harris Methodist Hospital Alliance at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Texas Health Harris Methodist Hospital Alliance",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Texas Health Harris Methodist Hospital Alliance at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-kane-hall",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Kane Hall Barry Neurology: Dr. Jerome M. Kane",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Kane Hall Barry Neurology: Dr. Jerome M. Kane",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Kane Hall Barry Neurology: Dr. Jerome M. Kane.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Kane Hall Barry Neurology: Dr. Jerome M. Kane at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Kane Hall Barry Neurology: Dr. Jerome M. Kane",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Kane Hall Barry Neurology: Dr. Jerome M. Kane at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-encompass-health",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Encompass Health Rehabilitation Hospital of the Mid-Cities",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Encompass Health Rehabilitation Hospital of the Mid-Cities",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Encompass Health Rehabilitation Hospital of the Mid-Cities.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Encompass Health Rehabilitation Hospital of the Mid-Cities at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Encompass Health Rehabilitation Hospital of the Mid-Cities",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Encompass Health Rehabilitation Hospital of the Mid-Cities at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-hospital",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Southwest Surgical Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Southwest Surgical Hospital",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Southwest Surgical Hospital.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Southwest Surgical Hospital at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Southwest Surgical Hospital",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Southwest Surgical Hospital at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-tcc",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Tarrant County College - Northwest Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Tarrant County College - Northwest Campus",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Tarrant County College - Northwest Campus.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Tarrant County College - Northwest Campus at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Tarrant County College - Northwest Campus",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Tarrant County College - Northwest Campus at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-tccd",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Tarrant County College District Office",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Tarrant County College District Office",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Tarrant County College District Office.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Tarrant County College District Office at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Tarrant County College District Office",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Tarrant County College District Office at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-swbts",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Southwestern Baptist Theological Seminary",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Southwestern Baptist Theological Seminary",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Southwestern Baptist Theological Seminary.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Southwestern Baptist Theological Seminary at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Southwestern Baptist Theological Seminary",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Southwestern Baptist Theological Seminary at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-tcu",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Texas Christian University",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Texas Christian University",
      "h2_subtitle": "Experience luxury living at Cavalli at Iron Horse Station. Our apartments are conveniently located near Texas Christian University.",
      "page_copy": "Discover the finest apartments for rent in North Richland Hills TX near Texas Christian University at Cavalli at Iron Horse Station. Our community offers a variety of upscale amenities, including a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Resident Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located minutes from Interstate 820 and the TRE Iron Horse Station, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Texas Christian University",
      "seo_description": "Find luxury apartments for rent in North Richland Hills TX near Texas Christian University at Cavalli at Iron Horse Station. Upscale amenities and prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-high-school",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Richland High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Richland High School",
      "h2_subtitle": "Enjoy family-friendly living at Cavalli at Iron Horse Station. Our apartments are conveniently located just 1.9 km from Richland High School.",
      "page_copy": "Discover the ideal apartments for rent in North Richland Hills TX near Richland High School at Cavalli at Iron Horse Station. Perfect for families, our community offers a variety of spacious floor plans, including studio, one, two, and three-bedroom apartments. Our upscale amenities include a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Community Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located just 1.9 km from Richland High School, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Richland High School",
      "seo_description": "Find family-friendly apartments for rent in North Richland Hills TX near Richland High School at Cavalli at Iron Horse Station. Spacious floor plans and upscale amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-middle-school",
      "search_query": "Apartments For Rent In North Richland Hills TX Near North Richland Middle School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near North Richland Middle School",
      "h2_subtitle": "Enjoy family-friendly living at Cavalli at Iron Horse Station. Our apartments are conveniently located just 2.1 km from North Richland Middle School.",
      "page_copy": "Discover the ideal apartments for rent in North Richland Hills TX near North Richland Middle School at Cavalli at Iron Horse Station. Perfect for families, our community offers a variety of spacious floor plans, including studio, one, two, and three-bedroom apartments. Our upscale amenities include a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Community Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located just 2.1 km from North Richland Middle School, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near North Richland Middle School",
      "seo_description": "Find family-friendly apartments for rent in North Richland Hills TX near North Richland Middle School at Cavalli at Iron Horse Station. Spacious floor plans and upscale amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5737427910000640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-richland-hills-tx-near-snow-heights",
      "search_query": "Apartments For Rent In North Richland Hills TX Near Snow Heights Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Richland Hills TX Near Snow Heights Elementary School",
      "h2_subtitle": "Enjoy family-friendly living at Cavalli at Iron Horse Station. Our apartments are conveniently located just 2.4 km from Snow Heights Elementary School.",
      "page_copy": "Discover the ideal apartments for rent in North Richland Hills TX near Snow Heights Elementary School at Cavalli at Iron Horse Station. Perfect for families, our community offers a variety of spacious floor plans, including studio, one, two, and three-bedroom apartments. Our upscale amenities include a modern strength training and cardio studio, a relaxing Yoga Studio, and Well Beats virtual fitness classes. Socialize in our Community Game Room or unwind by the resort-style swimming pool with poolside cabanas, picnic, and barbecue grills. Each apartment is designed with your comfort in mind, featuring stainless steel kitchen appliances, decorative bathroom mirrors, and private patios or balconies. Conveniently located just 2.4 km from Snow Heights Elementary School, Cavalli at Iron Horse Station combines luxury and convenience for an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with stone accents and blue trim.",
        "public_id": "019f6c0d-2046-76eb-b33f-7f87852eb5c4",
        "storage_key": "property/5737427910000640/019f6c0d-2046-76eb-b33f-7f87852eb5c4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0d-28f9-7788-b094-638cea59413a",
        "storage_key": "property/5737427910000640/019f6c0d-28f9-7788-b094-638cea59413a.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cavalli at Iron Horse Station | Apartments For Rent In North Richland Hills TX Near Snow Heights Elementary School",
      "seo_description": "Find family-friendly apartments for rent in North Richland Hills TX near Snow Heights Elementary School at Cavalli at Iron Horse Station. Spacious floor plans and upscale amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2127"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2341589756"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4951746"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N69996B"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://cavalliati.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8007243961"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epmyn84p6d"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ebd3f3fa-2fb3-48de-b775-c575ae9464dc"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-961-9003"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ino5UUljMTNMWXZHQkhmMFhldUU3YlE9PSIsInZhbHVlIjoiU09aczhtcStIVWYzSm5hNUlYNmVPdz09IiwibWFjIjoiMjA0OTM1YjExMWQ2ODUyNTkyNmQzY2NlMWE0ZWEzYmQ3NDdmNmQzYmJlZDc1ZmFmYWI1YTAxMTQzOTIxZDJmYiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2127",
  "custom_repli_id": "2341589756",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4951746",
  "custom_google_gtm_id": "GTM-N69996B",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://cavalliati.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8007243961",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8epmyn84p6d",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ebd3f3fa-2fb3-48de-b775-c575ae9464dc",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-961-9003",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ino5UUljMTNMWXZHQkhmMFhldUU3YlE9PSIsInZhbHVlIjoiU09aczhtcStIVWYzSm5hNUlYNmVPdz09IiwibWFjIjoiMjA0OTM1YjExMWQ2ODUyNTkyNmQzY2NlMWE0ZWEzYmQ3NDdmNmQzYmJlZDc1ZmFmYWI1YTAxMTQzOTIxZDJmYiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ee71178e-3199-4c23-925f-e3d725bf4bb1",
  "custom_audioeye_site_hash": "7b3ce17dfa31f1a905f200531e8e5a2f"
};

export const generatedAt = '2026-11-03T20:37:41.235Z';
